
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bbZCI", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $8C5kA = parcelRequire("8C5kA");

var $479a090f69cfa515$exports = {};
var $04edbe5e5395e00f$exports = {};

var $hWvFC = parcelRequire("hWvFC");


var $bRRFB = parcelRequire("bRRFB");


var $d6TaN = parcelRequire("d6TaN");

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $04edbe5e5395e00f$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$bRRFB(collection)) {
            var iteratee = $hWvFC(predicate, 3);
            collection = $d6TaN(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
$04edbe5e5395e00f$exports = $04edbe5e5395e00f$var$createFind;


var $c7faf66d496f60a0$exports = {};

var $kQ62s = parcelRequire("kQ62s");





var $ehlgT = parcelRequire("ehlgT");

/* Built-in method references for those with the same name as other `lodash` methods. */ var $c7faf66d496f60a0$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $c7faf66d496f60a0$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $ehlgT(fromIndex);
    if (index < 0) index = $c7faf66d496f60a0$var$nativeMax(length + index, 0);
    return $kQ62s(array, $hWvFC(predicate, 3), index);
}
$c7faf66d496f60a0$exports = $c7faf66d496f60a0$var$findIndex;


/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $479a090f69cfa515$var$find = $04edbe5e5395e00f$exports($c7faf66d496f60a0$exports);
$479a090f69cfa515$exports = $479a090f69cfa515$var$find;



var $kyKWe = parcelRequire("kyKWe");


var $2XqLN = parcelRequire("2XqLN");


var $inPa6 = parcelRequire("inPa6");


var $if5rb = parcelRequire("if5rb");


var $4TXTZ = parcelRequire("4TXTZ");


var $cH0F8 = parcelRequire("cH0F8");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

var $1kHsc = parcelRequire("1kHsc");


var $9wGTI = parcelRequire("9wGTI");


var $e4o8D = parcelRequire("e4o8D");


var $5Abqh = parcelRequire("5Abqh");


var $kVysQ = parcelRequire("kVysQ");


var $9eE57 = parcelRequire("9eE57");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");


var $id4ij = parcelRequire("id4ij");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aMcHK = parcelRequire("aMcHK");


var $4PPzL = parcelRequire("4PPzL");


var $lpPVE = parcelRequire("lpPVE");


var $71GjD = parcelRequire("71GjD");


var $gqqjz = parcelRequire("gqqjz");


var $ep3mz = parcelRequire("ep3mz");


var $7xVCs = parcelRequire("7xVCs");


var $dPJCf = parcelRequire("dPJCf");


var $b8XTE = parcelRequire("b8XTE");


var $7d2Nc = parcelRequire("7d2Nc");


var $56QzY = parcelRequire("56QzY");


var $39rFu = parcelRequire("39rFu");


var $7Sm4c = parcelRequire("7Sm4c");


var $huWyw = parcelRequire("huWyw");


var $de2j9 = parcelRequire("de2j9");


var $lqy4C = parcelRequire("lqy4C");


var $gz8ZY = parcelRequire("gz8ZY");


var $d0oNo = parcelRequire("d0oNo");


var $6g38M = parcelRequire("6g38M");


var $ivyMZ = parcelRequire("ivyMZ");


var $lUMkS = parcelRequire("lUMkS");





var $5izcQ = parcelRequire("5izcQ");


var $jmjWc = parcelRequire("jmjWc");


const $fc9136784916e31b$export$5963eb3a3cd0b4b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "mwUhV",
    name: "RtPaidFeatureEducationSpotlightTargetLoadable",
    loader: async ()=>(await (parcelRequire("llP7S"))).RtPaidFeatureEducationSpotlightTarget
});



var $6mKj3 = parcelRequire("6mKj3");


var $3aAh8 = parcelRequire("3aAh8");

function $23e76f192fd1fdb2$export$4240bef965f11267({ item: item, ...passThroughRenderItemParams }, additionalParams) {
    const { scrollToItem: scrollToItem, onPageHighlighted: onPageHighlighted, onClick: onClick, onExpand: onExpand, onCollapse: onCollapse, spaceId: spaceId, openQuickActionsId: openQuickActionsId, focusedQuickActionsId: focusedQuickActionsId, editingTitle: editingTitle, pageTreeWasSSRRendered: pageTreeWasSSRRendered, getContentTreeSize: getContentTreeSize, renderServerPlaceholder: renderServerPlaceholder = false, ...passThroughAdditionalParams } = additionalParams;
    const isDraft = item.data.status === 'DRAFT';
    const contentStatus = item.data.status;
    const isPaidEditionItem = item.data.type === 'page' && item.data.fullTitle === 'Explore Confluence Features';
    const scrollToRef = (()=>{
        // skip scrollTo if page is SSR'd, SSR scrolling is handled by separate script
        if (!pageTreeWasSSRRendered) return (el)=>{
            scrollToItem(item, el);
        };
    })();
    const addSpotlight = (target)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
            name: "page-tree-spotlight"
        }, target);
    const addExperimentSpotlight = (target, webUi)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fc9136784916e31b$export$5963eb3a3cd0b4b), {
            webUi: webUi
        }, target);
    const isQuickActionsOpen = openQuickActionsId === item.id;
    const isQuickActionsFocused = focusedQuickActionsId === item.id;
    const onHighlight = ()=>onPageHighlighted(item.id);
    const onClickWithItem = (event)=>{
        onClick(event, item, onExpand, onCollapse, spaceId, getContentTreeSize);
    };
    const pageItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "item",
        "data-testid": "page-tree-item-wrapper",
        "data-vc": "page-tree-item-wrapper",
        "data-ssr-placeholder": renderServerPlaceholder && (0, $6mKj3.expVal)('page_tree_performance', 'isEnabled', false) ? `pagetree-ssr-${item.id}` : undefined,
        "data-ssr-placeholder-replace": window.__SSR_RENDERED__ === true && (0, $6mKj3.expVal)('page_tree_performance', 'isEnabled', false) ? `pagetree-ssr-${item.id}` : undefined,
        ref: scrollToRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3aAh8.PageTreeItem), {
        ...passThroughRenderItemParams,
        ...passThroughAdditionalParams,
        "data-testid": "page-tree-item",
        item: item,
        onHighlight: onHighlight,
        onClick: onClickWithItem,
        isQuickActionsOpen: isQuickActionsOpen,
        isQuickActionsFocused: isQuickActionsFocused,
        editingTitle: editingTitle,
        isDraft: isDraft,
        contentStatus: contentStatus,
        renderServerPlaceholder: renderServerPlaceholder && (0, $6mKj3.expVal)('page_tree_performance', 'isEnabled', false)
    }));
    if (isPaidEditionItem) return addExperimentSpotlight(pageItem, item.data.webui ?? null);
    return item.data.isSelected ? addSpotlight(pageItem) : pageItem;
}



var $55DRn = parcelRequire("55DRn");


var $88DkZ = parcelRequire("88DkZ");

class $cb5c80eb65176243$export$fbe5b8b514d54d78 {
    push({ undo: undo }) {
        this.stack.push({
            undo: undo
        });
        this.stack = this.stack.slice(-1 * this.size);
    }
    constructor(){
        this.size = 1;
        this.stack = [];
        this.pop = ()=>this.stack.pop();
        this.peek = ()=>this.stack.slice(-1)[0];
        this.reset = ()=>{
            this.stack = [];
        };
    }
}



var $1q7H7 = parcelRequire("1q7H7");


var $6FfmH = parcelRequire("6FfmH");


var $cdzEA = parcelRequire("cdzEA");


var $6CrbN = parcelRequire("6CrbN");


var $bP5d8 = parcelRequire("bP5d8");

const $a4f80453e05e0dd2$var$noop = ()=>{};
const $a4f80453e05e0dd2$var$canMoveInSpace = (0, $2XqLN.default)((space)=>{
    return !!(0, (/*@__PURE__*/$parcel$interopDefault($479a090f69cfa515$exports)))(space?.operations ?? [], {
        targetType: 'page',
        operation: 'create'
    });
}, ([newSpace], [lastSpace])=>{
    return newSpace?.id === lastSpace?.id;
});
const $a4f80453e05e0dd2$var$isMovePagePermissionError = ({ graphQLErrors: graphQLErrors })=>{
    if (!graphQLErrors?.length) return false;
    for (const graphQLError of graphQLErrors){
        if (Array.isArray(graphQLError.path) && graphQLError.path.some((p)=>p.includes('movePage')) && (0, $aMcHK.getStatusCode)(graphQLError) === '403') return true;
        if (graphQLError.message?.includes('PermissionException')) return true;
    }
    return false;
};
const $a4f80453e05e0dd2$var$usePageTreeMoveHistory = ({ spaceKey: spaceKey, flags: flags, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>{
    const previousSpaceKeyRef = (0, $42omo.useRef)(spaceKey);
    const pageMoveHistoryRef = (0, $42omo.useRef)(new (0, $cb5c80eb65176243$export$fbe5b8b514d54d78)());
    const undo = (0, $42omo.useCallback)(()=>{
        const reverseMovement = pageMoveHistoryRef.current.pop();
        if (reverseMovement) {
            const { undo: undoFn } = reverseMovement;
            if (undoFn) undoFn();
        }
    }, []);
    const onUndoShortcut = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent((0, $88DkZ.undoShortcutUIEvent)()).fire();
        undo();
    }, [
        createAnalyticsEvent,
        undo
    ]);
    const showUndoFlag = (0, $42omo.useCallback)((pageTitle)=>{
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        flags.showSuccessFlag({
            id: id,
            title: pageTitle ? intl.formatMessage((0, $bP5d8.i18n).flagUndoTitle, {
                pageTitle: pageTitle
            }) : intl.formatMessage((0, $bP5d8.i18n).flagUndoUntitled),
            actions: [
                {
                    content: intl.formatMessage((0, $bP5d8.i18n).flagUndoAction),
                    onClick: ()=>{
                        createAnalyticsEvent((0, $88DkZ.undoClickUIEvent)()).fire();
                        undo();
                        flags.hideFlag(id);
                    }
                }
            ],
            isAutoDismiss: true
        });
        const historyEntry = pageMoveHistoryRef.current.peek();
        if (historyEntry) historyEntry.flagId = id;
    }, [
        flags,
        intl,
        createAnalyticsEvent,
        undo
    ]);
    const hideLastUndoFlag = (0, $42omo.useCallback)(()=>{
        const lastMovement = pageMoveHistoryRef.current.peek();
        if (lastMovement) flags.hideFlag(lastMovement.flagId);
    }, [
        flags
    ]);
    const addUndo = (0, $42omo.useCallback)(({ undo: undo_0 })=>{
        pageMoveHistoryRef.current.push({
            undo: undo_0
        });
    }, []);
    if (spaceKey !== previousSpaceKeyRef.current) {
        previousSpaceKeyRef.current = spaceKey;
        hideLastUndoFlag();
        pageMoveHistoryRef.current.reset();
    }
    return {
        onUndoShortcut: onUndoShortcut,
        showUndoFlag: showUndoFlag,
        hideLastUndoFlag: hideLastUndoFlag,
        addUndo: addUndo
    };
};
const $a4f80453e05e0dd2$var$useScrollToItem = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { pageTreeStateUpdatesContainer: pageTreeStateUpdatesContainer } = t0;
    const scrolledItemIdRef = (0, $42omo.useRef)();
    const { nav4GlobalChangeboardingActive: nav4GlobalChangeboardingActive, nav4SpaceSettingsChangeboardingActive: nav4SpaceSettingsChangeboardingActive } = (0, $d0oNo.useModernizeChangeboardingState)();
    let t1;
    if ($[0] !== nav4GlobalChangeboardingActive || $[1] !== nav4SpaceSettingsChangeboardingActive || $[2] !== pageTreeStateUpdatesContainer) {
        t1 = (item, el)=>{
            if ((nav4GlobalChangeboardingActive || nav4SpaceSettingsChangeboardingActive) && (0, $9wGTI.fg)("cc_modernize_ga_changeboarding")) return;
            if (pageTreeStateUpdatesContainer.state.scrollToPageId === item.id && el) {
                (0, $id4ij.scrollElementToViewCenter)(el);
                pageTreeStateUpdatesContainer.clearScrollToPageId();
                return;
            }
            if (!pageTreeStateUpdatesContainer.state.editingTitle?.contentId && (item.data.isSelected || item.data.isHighlighted)) {
                if (pageTreeStateUpdatesContainer.state.scrollToCurrent && item.data.isSelected && el) {
                    (0, $id4ij.scrollElementToViewCenter)(el);
                    pageTreeStateUpdatesContainer.clearScrollTo();
                    return;
                }
                if (scrolledItemIdRef.current !== item.id) (0, $id4ij.scrollElementToViewCenter)(el);
                scrolledItemIdRef.current = item.id;
            }
        };
        $[0] = nav4GlobalChangeboardingActive;
        $[1] = nav4SpaceSettingsChangeboardingActive;
        $[2] = pageTreeStateUpdatesContainer;
        $[3] = t1;
    } else t1 = $[3];
    const scrollToItem = t1;
    let t2;
    if ($[4] !== scrollToItem) {
        t2 = [
            scrollToItem
        ];
        $[4] = scrollToItem;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ pageTreeStateUpdatesContainer: pageTreeStateUpdatesContainer })=>{
    const scrolledItemIdRef = (0, $42omo.useRef)();
    const { nav4GlobalChangeboardingActive: nav4GlobalChangeboardingActive, nav4SpaceSettingsChangeboardingActive: nav4SpaceSettingsChangeboardingActive } = (0, $d0oNo.useModernizeChangeboardingState)();
    const scrollToItem = (0, $42omo.useCallback)((item, el)=>{
        // Prevent scrolling when rendering certain nav4 spotlights in side nav
        if ((nav4GlobalChangeboardingActive || nav4SpaceSettingsChangeboardingActive) && (0, $9wGTI.fg)('cc_modernize_ga_changeboarding')) return;
        if (pageTreeStateUpdatesContainer.state.scrollToPageId === item.id && el) {
            (0, $id4ij.scrollElementToViewCenter)(el);
            pageTreeStateUpdatesContainer.clearScrollToPageId();
            return;
        }
        if (!pageTreeStateUpdatesContainer.state.editingTitle?.contentId && (item.data.isSelected || item.data.isHighlighted)) {
            if (pageTreeStateUpdatesContainer.state.scrollToCurrent && item.data.isSelected && el) {
                (0, $id4ij.scrollElementToViewCenter)(el);
                pageTreeStateUpdatesContainer.clearScrollTo();
                return;
            }
            if (scrolledItemIdRef.current !== item.id) // Scroll only once to a given page
            (0, $id4ij.scrollElementToViewCenter)(el);
            scrolledItemIdRef.current = item.id;
        }
    }, [
        pageTreeStateUpdatesContainer,
        nav4GlobalChangeboardingActive,
        nav4SpaceSettingsChangeboardingActive
    ]);
    return [
        scrollToItem
    ];
};
const $a4f80453e05e0dd2$var$usePageHighlight = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { pageTreeStateUpdatesContainer: pageTreeStateUpdatesContainer } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const highlightedPages = (0, $42omo.useRef)(t1);
    let t2;
    if ($[1] !== pageTreeStateUpdatesContainer) {
        t2 = (id)=>{
            highlightedPages.current.push(id);
            const pagesInTreeHighlighted = pageTreeStateUpdatesContainer.state.highlightPagesIds;
            if (highlightedPages.current.length === pagesInTreeHighlighted.length) {
                pageTreeStateUpdatesContainer.clearHighlightedPages();
                highlightedPages.current = [];
            }
        };
        $[1] = pageTreeStateUpdatesContainer;
        $[2] = t2;
    } else t2 = $[2];
    const onPageHighlighted = t2;
    let t3;
    if ($[3] !== onPageHighlighted) {
        t3 = [
            onPageHighlighted
        ];
        $[3] = onPageHighlighted;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ pageTreeStateUpdatesContainer: pageTreeStateUpdatesContainer })=>{
    const highlightedPages = (0, $42omo.useRef)([]);
    const onPageHighlighted = (0, $42omo.useCallback)((id)=>{
        highlightedPages.current.push(id);
        // keep a tally of the successfully highlighted pages and notify
        // parent when they've all completed
        const pagesInTreeHighlighted = pageTreeStateUpdatesContainer.state.highlightPagesIds;
        // Checking length rather than deep equality prevents UI weirdness
        // should there happen to be a mismatch. (In that case, deep equality
        // condition would never pass for duration of this component's life, and
        // we would keep re-highlighting the same pages on every tree render.)
        // @TODO FIXME to use Set instead of array.
        if (highlightedPages.current.length === pagesInTreeHighlighted.length) {
            pageTreeStateUpdatesContainer.clearHighlightedPages();
            highlightedPages.current = [];
        }
    }, [
        pageTreeStateUpdatesContainer
    ]);
    return [
        onPageHighlighted
    ];
};
/**
 * This component is what makes the generic `PageTreeController` into a fully functional
 * navigational Page Tree that we all love. It is the one to actually handle things like:
 *  - analytics, performance, and experience tracking events
 *  - backend mutations after drag-n-drop
 *  - orchestrating "undo" for the d-n-d
 *  - showing flags of various kinds (successes/failures). Although triggers for these might originate in other components.
 */ const $a4f80453e05e0dd2$var$PageTreeInner = ({ isInDrawer: isInDrawer = false, onDragDropSuccess: onDragDropSuccess = $a4f80453e05e0dd2$var$noop, onItemClick: onItemClick, isPeekingFromBlogs: isPeekingFromBlogs, isSuperAdmin: isSuperAdmin = false, pageTreeStateUpdatesContainer: pageTreeStateUpdatesContainer, flags: flags, setIsPageTreeLoading: setIsPageTreeLoading, setPageTreeError: setPageTreeError = $a4f80453e05e0dd2$var$noop, isHoverPageCardOptedIn: isHoverPageCardOptedIn = false, closeAllHoverPageCards: closeAllHoverPageCards = $a4f80453e05e0dd2$var$noop, isQuickActionsEnabled: isQuickActionsEnabled = false, isInlineRenameEnabled: isInlineRenameEnabled = false, onEnterHoverTarget: onEnterHoverTarget = $a4f80453e05e0dd2$var$noop, onLeaveHoverTarget: onLeaveHoverTarget = $a4f80453e05e0dd2$var$noop, onBlurHoverTarget: onBlurHoverTarget = $a4f80453e05e0dd2$var$noop, shouldRenderAfterIcon: shouldRenderAfterIcon, homepageId: homepageId, setContentTreeSize: setContentTreeSize = $a4f80453e05e0dd2$var$noop, onContentTreeLoadComplete: onContentTreeLoadComplete = $a4f80453e05e0dd2$var$noop })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $8C5kA.default)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const [{ spaceKey: stateSpaceKey, contentId: contentId, contentIdLoading: contentIdLoading, routeName: routeName }] = (0, $ep3mz.usePageState)();
    // Many analytics callbacks are sending the current viewing page. The problem is these callbacks are passed to every page tree item.
    // If we use contentId directly the callback functions are going to be regenerated and making all page tree items re-render.
    const contentIdForAnalyticsRef = (0, $42omo.useRef)(contentId);
    // @ts-ignore FIXME: `stateSpaceKey` can be `undefined` here, and needs proper handling
    const spaceKey = stateSpaceKey;
    const { loadEditor: loadEditor } = (0, $39rFu.useEditPageLoadingActions)();
    const [openQuickActionsId, setOpenQuickActionsId] = (0, $42omo.useState)(null);
    const [focusedQuickActionsId, setFocusedQuickActionsId] = (0, $42omo.useState)(null);
    const { setIsDraggingItem: setIsDraggingItem, getIsDraggingItem: getIsDraggingItem } = (0, $6CrbN.useIsDragging)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const isOnEditRouteRef = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        isOnEditRouteRef.current = isOnEditRoute;
        contentIdForAnalyticsRef.current = contentId;
    }, [
        isOnEditRoute,
        contentId
    ]);
    const renderResourcedEmoji = (0, $42omo.useRef)(false);
    const { onUndoShortcut: onUndoShortcut, showUndoFlag: showUndoFlag, hideLastUndoFlag: hideLastUndoFlag, addUndo: addUndo } = $a4f80453e05e0dd2$var$usePageTreeMoveHistory({
        flags: flags,
        intl: intl,
        createAnalyticsEvent: createAnalyticsEvent,
        spaceKey: spaceKey
    });
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'page-tree-page-tree-item'
    });
    const { sendInitiatedEvent: sendInitiatedEvent } = (0, $cH0F8.useConsumptionEvents)();
    const visitPage = (0, $42omo.useCallback)((event, page, spaceId, getContentTreeSize)=>{
        const contentTreeSize = getContentTreeSize?.();
        closeAllHoverPageCards?.();
        createAnalyticsEvent((0, $88DkZ.pageTreeUIAnalytics)('clicked', spaceId, //spaceId was already passing Undefined
        isInDrawer, isNav4Enabled, page.data?.status, contentIdForAnalyticsRef.current, page.data?.type, (0, $56QzY.START_TOUCH), isOnEditRouteRef.current, contentTreeSize, spaceKey)).fire();
        // metaKey = ⌘ in macOS or middle scroll mouse button
        // Use default browser behaviour when any of these key was pressed
        if (event.metaKey || event.shiftKey || event.altKey || event.ctrlKey || event.button === 1) {
            event.currentTarget.href = (0, $lpPVE.generatePathWithFeatureCodesQueryParam)(event.currentTarget.href, [
                (0, $71GjD.FeatureCode).PAGE_TREE
            ]);
            return; // let the link's href handle the navigation
        }
        sendInitiatedEvent({
            contentId: page.id,
            spaceKey: spaceKey,
            source: 'PageTree',
            utmSource: 'PAGETREE'
        });
        const url = `${(0, $jlIaF.CONTEXT_PATH)}${page.data?.webui}`;
        const bypassURL = (0, $huWyw.getURLBypassingResumeDraftAction)({
            url: url,
            spaceKey: spaceKey,
            contentType: page?.data?.type,
            editorVersion: page?.data?.editorVersion,
            contentId: page.id
        });
        const isDraft = page.data?.status === 'DRAFT';
        if (isDraft) {
            event.preventDefault();
            event.stopPropagation();
            loadEditor({
                contentId: page.id,
                spaceKey: spaceKey,
                redirectUrl: bypassURL,
                isFabricSupported: page?.data?.editorVersion === 'v2',
                isEmbeddedContent: false
            });
        } else {
            event.preventDefault();
            push((0, $lpPVE.generatePathWithFeatureCodesQueryParam)(url, [
                (0, $71GjD.FeatureCode).PAGE_TREE
            ]));
        }
        if (onItemClick) onItemClick();
    }, [
        push,
        onItemClick,
        closeAllHoverPageCards,
        createAnalyticsEvent,
        isInDrawer,
        spaceKey,
        loadEditor,
        isOnEditRouteRef,
        isNav4Enabled,
        sendInitiatedEvent
    ]);
    const handleClick = (0, $42omo.useCallback)((event_0, page_0, onExpand, onCollapse, ...args)=>{
        if (page_0.data.type === 'folder') {
            event_0.preventDefault();
            page_0.isExpanded ? onCollapse?.(page_0.id) : onExpand?.(page_0.id);
            if (page_0.isExpanded) (0, $4TXTZ.default)('page-tree-item-collapse', event_0.timeStamp);
            else (0, $4TXTZ.default)('page-tree-item-expand', event_0.timeStamp);
            return;
        }
        // Check for storage enforcement before sending users through to draft pages
        const isDraft_0 = page_0.data?.status === 'DRAFT';
        (isDraft_0 ? enforceStorageLimit(visitPage) : visitPage)(event_0, page_0, ...args);
    }, [
        visitPage,
        enforceStorageLimit
    ]);
    const draftText = intl.formatMessage((0, $bP5d8.i18n).untitledDraftText);
    const dragPreview = (0, $42omo.useCallback)((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cdzEA.DragPreview), {
            item: item
        }), []);
    const statusesRef = (0, $42omo.useRef)((0, $ivyMZ.PAGE_TREE_STATUSES));
    const [scrollToItem] = $a4f80453e05e0dd2$var$useScrollToItem({
        pageTreeStateUpdatesContainer: pageTreeStateUpdatesContainer
    });
    const [onPageHighlighted] = $a4f80453e05e0dd2$var$usePageHighlight({
        pageTreeStateUpdatesContainer: pageTreeStateUpdatesContainer
    });
    const { movePage: movePage } = (0, $55DRn.useMovePageHandler)();
    const [dndError, setDnDError] = (0, $42omo.useState)(null);
    const [initialLoadComplete, setInitialLoadComplete] = (0, $42omo.useState)(false);
    const [initialPageTreeSize, setInitialPageTreeSize] = (0, $42omo.useState)(0);
    const pageTreeWasSSRRendered = (0, $5Abqh.checkSSRPartialSuccess)((0, $5Abqh.SSR_PARTIAL_COMPONENT).PageTree);
    if (!renderResourcedEmoji.current && pageTreeWasSSRRendered) renderResourcedEmoji.current = true;
    const managedOnEnterHoverTarget = (0, $42omo.useCallback)((...args_0)=>{
        // while a drag is occurring, we don't also items to have their hover action triggered
        if (!getIsDraggingItem()) onEnterHoverTarget(...args_0);
    }, [
        onEnterHoverTarget,
        getIsDraggingItem
    ]);
    const editingTitle = pageTreeStateUpdatesContainer.state.editingTitle;
    const isEditingTitleId = editingTitle?.contentId;
    const setIsEditingTitleId = (0, $42omo.useCallback)((pageId)=>{
        return pageTreeStateUpdatesContainer.setIsEditingTitleId(pageId);
    }, [
        pageTreeStateUpdatesContainer
    ]);
    const clearDelete = (0, $42omo.useCallback)(()=>{
        pageTreeStateUpdatesContainer.clearOptimisticDeleteId();
    }, [
        pageTreeStateUpdatesContainer
    ]);
    /**
   * We are registering an "open layer" when the quick actions panel is open, or if we are renaming
   * a page title.
   *
   * This is used to keep the side nav flyout open while the user is renaming a page inline.
   */ (0, $if5rb.useNotifyOpenLayerObserver)({
        isOpen: Boolean(openQuickActionsId || isEditingTitleId),
        // Providing a noop for now. In the future, we may want to cancel any pending renames when a close
        // signal is received. This will be explored in https://jplat.atlassian.net/browse/BLU-7168
        onClose: $a4f80453e05e0dd2$var$noop
    });
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const renderItem = (0, $42omo.useCallback)((params)=>{
        const { spaceHomePageId: spaceHomePageId, updateSinglePage: updateSinglePage, spaceId: spaceId_0, getContentTreeSize: getContentTreeSize_0, ...renderItemParams } = params;
        return (0, $23e76f192fd1fdb2$export$4240bef965f11267)(renderItemParams, {
            draftText: draftText,
            isSuperAdmin: isSuperAdmin,
            spaceHomePageId: spaceHomePageId,
            onClick: handleClick,
            onExpand: renderItemParams.onExpand,
            onCollapse: renderItemParams.onCollapse,
            spaceKey: spaceKey,
            spaceId: spaceId_0,
            scrollToItem: scrollToItem,
            onPageHighlighted: onPageHighlighted,
            isHoverPageCardOptedIn: isHoverPageCardOptedIn,
            isQuickActionsEnabled: isQuickActionsEnabled,
            isInlineRenameEnabled: isInlineRenameEnabled,
            closeAllHoverPageCards: closeAllHoverPageCards,
            openQuickActionsId: openQuickActionsId,
            setOpenQuickActionsId: setOpenQuickActionsId,
            focusedQuickActionsId: focusedQuickActionsId,
            setFocusedQuickActionsId: setFocusedQuickActionsId,
            editingTitle: editingTitle,
            setIsEditingTitleId: setIsEditingTitleId,
            onEnterHoverTarget: managedOnEnterHoverTarget,
            onLeaveHoverTarget: onLeaveHoverTarget,
            onBlurHoverTarget: onBlurHoverTarget,
            updateSinglePage: updateSinglePage,
            pageTreeWasSSRRendered: pageTreeWasSSRRendered,
            renderResourcedEmoji: renderResourcedEmoji.current,
            shouldRenderAfterIcon: shouldRenderAfterIcon,
            hideDraftHrefs: shouldBlockCreate,
            getContentTreeSize: getContentTreeSize_0,
            renderServerPlaceholder: renderServerPlaceholder
        });
    }, [
        draftText,
        isSuperAdmin,
        handleClick,
        spaceKey,
        scrollToItem,
        onPageHighlighted,
        isHoverPageCardOptedIn,
        isQuickActionsEnabled,
        isInlineRenameEnabled,
        closeAllHoverPageCards,
        openQuickActionsId,
        focusedQuickActionsId,
        editingTitle,
        setIsEditingTitleId,
        managedOnEnterHoverTarget,
        onLeaveHoverTarget,
        onBlurHoverTarget,
        pageTreeWasSSRRendered,
        shouldRenderAfterIcon,
        renderResourcedEmoji,
        shouldBlockCreate,
        renderServerPlaceholder
    ]);
    (0, $42omo.useEffect)(()=>{
        if (pageTreeWasSSRRendered) //set FMP now if SSR rendered and we didn't skip pageTree rendering
        (0, $1q7H7.PAGE_TREE_METRIC).markFMP((0, $9eE57.getMark)('CFP-63.ssr-ttr'));
    }, [
        pageTreeWasSSRRendered
    ]);
    const onLoadError = (0, $42omo.useCallback)((apolloError, options)=>{
        flags.showErrorFlag({
            title: intl.formatMessage((0, $bP5d8.i18n).flagErrorTitle),
            description: location ? intl.formatMessage((0, $bP5d8.i18n).paginateErrorDescription) : intl.formatMessage((0, $bP5d8.i18n).flagErrorDescription),
            isAutoDismiss: true
        });
        if (options?.isExpected) // This is a temporary measure as we gradually improve PageTree error handling.
        // Normally expected errors should not render a generic error component and
        // instead should provide an error-specific experience.
        experienceTracker.succeed({
            name: (0, $irVI7.PAGE_TREE_EXPERIENCE)
        });
        else {
            setPageTreeError(apolloError);
            experienceTracker.stopOnError({
                name: (0, $irVI7.PAGE_TREE_EXPERIENCE),
                attributes: {
                    location: options?.location || 'main'
                },
                error: apolloError
            });
        }
    }, [
        flags,
        intl,
        experienceTracker,
        setPageTreeError
    ]);
    const onPageMove = (0, $42omo.useCallback)((moveParams, { contentStatus: contentStatus, movedPageTitle: movedPageTitle, spaceId: spaceId_1, source: source, destination: destination, instructionType: instructionType, revertMove: revertMove })=>{
        createAnalyticsEvent((0, $88DkZ.dragEndUIEvent)(true)).fire();
        const handleDragDropSuccess = (spaceId_2, pageId_0, sourceParentId, destinationParentId, instructionType_0, isAmnPage = false)=>{
            createAnalyticsEvent((0, $88DkZ.dragDropEndTrackEvent)({
                source: 'PageTree',
                contentStatus: contentStatus,
                pageId: pageId_0,
                previousParentPageId: sourceParentId,
                newParentPageId: destinationParentId,
                previousSpaceId: spaceId_2,
                newSpaceId: spaceId_2,
                isOnEditRoute: isOnEditRouteRef.current,
                instructionType: instructionType_0,
                isAmnPage: isAmnPage
            })).fire();
            experienceTracker.succeed({
                name: (0, $irVI7.PAGE_TREE_DND_EXPERIENCE)
            });
            onDragDropSuccess(pageId_0);
        };
        const handleDndError = (apolloError_0)=>{
            // undo the move in state so that the tree reflects that the move did not succeed
            revertMove();
            if (!apolloError_0) return;
            const i18nMessage = (0, $6FfmH.getI18nMessageForKnownError)(apolloError_0);
            if (i18nMessage !== undefined) {
                (0, $7Sm4c.markErrorAsHandled)(apolloError_0);
                flags.showErrorFlag({
                    title: i18nMessage.title.defaultMessage,
                    description: i18nMessage.description.defaultMessage,
                    isAutoDismiss: true
                });
                experienceTracker.succeed({
                    name: (0, $irVI7.PAGE_TREE_DND_EXPERIENCE),
                    attributes: {
                        expectedErrorDescription: i18nMessage.description.defaultMessage
                    }
                });
            } else if ($a4f80453e05e0dd2$var$isMovePagePermissionError(apolloError_0)) {
                (0, $7Sm4c.markErrorAsHandled)(apolloError_0);
                flags.showErrorFlag({
                    title: intl.formatMessage((0, $bP5d8.i18n).flagMovePagePermissionErrorTitle),
                    description: intl.formatMessage((0, $bP5d8.i18n).flagMovePagePermissionErrorDescription),
                    isAutoDismiss: true
                });
                experienceTracker.abort({
                    name: (0, $irVI7.PAGE_TREE_DND_EXPERIENCE),
                    reason: 'User lacks move permissions'
                });
            } else {
                flags.showErrorFlag({
                    title: intl.formatMessage((0, $bP5d8.i18n).flagErrorTitle),
                    description: intl.formatMessage((0, $bP5d8.i18n).flagErrorDescription),
                    isAutoDismiss: true
                });
                experienceTracker.stopOnError({
                    name: (0, $irVI7.PAGE_TREE_DND_EXPERIENCE),
                    error: apolloError_0
                });
            }
            setDnDError(apolloError_0);
        };
        const makeMovePageRequests = async (movePageParams, onMovePageSuccess)=>{
            // Use allSettled as failures from getAutomatedMeetingNotesPageProperties should not result in a movePage failure
            const [movePageResult, amnPagePropsResult] = await Promise.allSettled([
                movePage(movePageParams).then(onMovePageSuccess),
                (0, $6g38M.getAutomatedMeetingNotesPageProperties)(movePageParams.pageId)
            ]);
            if (movePageResult.status === 'rejected') throw movePageResult.reason;
            const isAmnPage_0 = amnPagePropsResult.status === 'fulfilled' ? amnPagePropsResult.value.isAMN : undefined;
            return {
                movePageResult: movePageResult.value,
                isAmnPage: isAmnPage_0
            };
        };
        const reverseMove = ()=>{
            const reverseMoveParams = revertMove();
            makeMovePageRequests(reverseMoveParams).then(({ isAmnPage: isAmnPage_1 })=>handleDragDropSuccess(spaceId_1, moveParams.pageId, // If the move is reversed, the source will be the original destination
                // and the destination will be the original source.
                destination.parentId, source.parentId, instructionType, isAmnPage_1)).catch(handleDndError);
        };
        addUndo({
            undo: reverseMove
        });
        makeMovePageRequests(moveParams, ()=>showUndoFlag(movedPageTitle)).then(({ isAmnPage: isAmnPage_2 })=>handleDragDropSuccess(spaceId_1, moveParams.pageId, source.parentId, destination.parentId, instructionType, isAmnPage_2)).catch(handleDndError);
    }, [
        experienceTracker,
        flags,
        intl,
        addUndo,
        movePage,
        showUndoFlag,
        createAnalyticsEvent,
        onDragDropSuccess,
        isOnEditRouteRef
    ]);
    const forceFetchedCallback = (0, $42omo.useCallback)((state)=>{
        const lastForceFetchId = pageTreeStateUpdatesContainer.state.forceFetchPageId;
        pageTreeStateUpdatesContainer.clearForceFetch();
        const newContentId = editingTitle?.contentId;
        // For paginated page trees, force fetch id of the newly created content if the content does not
        // have a create content route. This will enable properly scrolling to the new item
        if ((state.isTreeTruncatedFollowing || state.isTreeTruncatedPrevious) && editingTitle?.isNewContent && lastForceFetchId !== newContentId) pageTreeStateUpdatesContainer.forceFetchWithInlineRename(newContentId, newContentId);
    }, [
        pageTreeStateUpdatesContainer,
        editingTitle
    ]);
    const onMoveInvalid = (0, $42omo.useCallback)(({ reason: reason })=>{
        createAnalyticsEvent((0, $88DkZ.dragEndUIEvent)(false)).fire();
        const showLargePageTreeFlag = ()=>{
            flags.showWarningFlag({
                title: intl.formatMessage((0, $bP5d8.i18n).flagLargePageTreeTitle),
                description: intl.formatMessage((0, $bP5d8.i18n).flagLargePageTreeDescription),
                actions: [
                    {
                        content: intl.formatMessage((0, $bP5d8.i18n).flagLargePageTreeSettingsAction),
                        onClick: ()=>{
                            push(`/wiki/pages/reorderpages.action?key=${spaceKey}`);
                        }
                    },
                    {
                        content: intl.formatMessage((0, $bP5d8.i18n).flagLargePageTreeRefreshAction),
                        onClick: ()=>window.location.reload()
                    }
                ],
                isAutoDismiss: true
            });
        };
        const showInvalidMoveDraftFlag = ()=>{
            flags.showErrorFlag({
                title: intl.formatMessage((0, $bP5d8.i18n).flagInvalidMoveDraftTitle),
                description: intl.formatMessage((0, $bP5d8.i18n).flagInvalidMoveDraftDescription),
                isAutoDismiss: true
            });
        };
        switch(reason){
            case 'TREE_TOO_LARGE':
                showLargePageTreeFlag();
                experienceTracker.abort({
                    name: (0, $irVI7.PAGE_TREE_DND_EXPERIENCE),
                    reason: 'Large page tree limit exceeded'
                });
                break;
            case 'INVALID_MOVE_LOCATION':
                experienceTracker.abort({
                    name: (0, $irVI7.PAGE_TREE_DND_EXPERIENCE),
                    reason: 'Invalid move location'
                });
                break;
            case 'INVALID_MOVE_LOCATION_DRAFT':
                showInvalidMoveDraftFlag();
                experienceTracker.abort({
                    name: (0, $irVI7.PAGE_TREE_DND_EXPERIENCE),
                    reason: 'Invalid move location onto draft'
                });
                break;
        }
    }, [
        createAnalyticsEvent,
        experienceTracker,
        flags,
        intl,
        push,
        spaceKey
    ]);
    const onDragStart = (0, $42omo.useCallback)(()=>{
        closeAllHoverPageCards();
        setOpenQuickActionsId(null);
        createAnalyticsEvent((0, $88DkZ.dragStartUIEvent)()).fire();
        experienceTracker.start({
            name: (0, $irVI7.PAGE_TREE_DND_EXPERIENCE)
        });
        hideLastUndoFlag();
    }, [
        createAnalyticsEvent,
        experienceTracker,
        hideLastUndoFlag,
        closeAllHoverPageCards
    ]);
    const expandAnalyticsCallback = (0, $42omo.useCallback)((page_1, { spaceId: spaceId_3 })=>{
        createAnalyticsEvent((0, $88DkZ.pageTreeUIAnalytics)('expanded', spaceId_3, isInDrawer, isNav4Enabled, page_1.data?.status, contentIdForAnalyticsRef.current, page_1.data?.type, (0, $56QzY.START_TOUCH), isOnEditRouteRef.current)).fire();
    }, [
        createAnalyticsEvent,
        isInDrawer,
        isOnEditRouteRef,
        isNav4Enabled
    ]);
    const collapseAnalyticsCallback = (0, $42omo.useCallback)((page_2, { spaceId: spaceId_4 })=>{
        createAnalyticsEvent((0, $88DkZ.pageTreeUIAnalytics)('collapsed', spaceId_4, isInDrawer, isNav4Enabled, page_2.data?.status, contentIdForAnalyticsRef.current, page_2.data?.type, (0, $56QzY.START_TOUCH), isOnEditRouteRef.current)).fire();
    }, [
        createAnalyticsEvent,
        isInDrawer,
        isOnEditRouteRef,
        isNav4Enabled
    ]);
    const isDraggable = (0, $42omo.useCallback)((item_0, { space: space })=>{
        if (item_0.id === isEditingTitleId) return false;
        return $a4f80453e05e0dd2$var$canMoveInSpace(space);
    }, [
        isEditingTitleId
    ]);
    const onLoadMore = (0, $42omo.useCallback)((pagesCount, spaceId_5, direction)=>{
        createAnalyticsEvent((0, $88DkZ.pageTreePaginationEvent)(spaceId_5, pagesCount, 'containerNavigation', direction)).fire();
    }, [
        createAnalyticsEvent
    ]);
    /**
   * onInitialLoadComplete is called after the first initial load of the page tree's data. This includes refreshing the page.
   * It does not include returning from blog peek, transitioning from blog BACK to page tree, transitioning amongst pages in page tree, etc.
   */ const onInitialLoadComplete = (0, $42omo.useCallback)((pagetreeSize)=>{
        (0, $9eE57.perfMarkEnd)({
            subject: (0, $kVysQ.PERFORMANCE_SUBJECT_navigation),
            subjectId: 'NavigationLoading',
            details: {
                navigationView: 'container',
                view: 'space',
                navVersion: 3,
                spaceKey: spaceKey
            }
        });
        (0, $9eE57.perfMarkEnd)({
            subject: (0, $kVysQ.PERFORMANCE_SUBJECT_navigationView),
            subjectId: 'SpaceViewLoading',
            details: {
                navigationView: 'container',
                view: 'space',
                navVersion: 3,
                spaceKey: spaceKey
            }
        });
        experienceTracker.succeed({
            name: (0, $irVI7.PAGE_TREE_EXPERIENCE)
        });
        onContentTreeLoadComplete(); // show blog tree spotlight only after page tree finishes loading to prevent misplaced spotlight
        if (pagetreeSize && pagetreeSize > 2) setInitialPageTreeSize(pagetreeSize - 2); //subtract 2 for VIRTUAL_LOCAL_ROOT_ID and VIRTUAL_ROOT_ID
        setInitialLoadComplete(true);
    }, [
        experienceTracker,
        spaceKey,
        onContentTreeLoadComplete
    ]);
    const currentPageId = pageTreeStateUpdatesContainer.state.forceFetchPageId || (isPeekingFromBlogs ? homepageId : contentId);
    const isCreateContentRoute = routeName === (0, $1NBp8.CREATE_CONTENT).name;
    // Note: content id can be null even when contentIdLoading = false
    // Because a space may not have homepage
    const showPageTree = Boolean(contentId) || !contentIdLoading;
    if (!showPageTree) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
        metric: (0, $1q7H7.PAGE_TREE_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        key: `experience-${spaceKey}`,
        name: (0, $irVI7.PAGE_TREE_EXPERIENCE),
        id: spaceKey
    }), dndError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: dndError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNDO_SHORTCUT),
        listener: onUndoShortcut
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lUMkS.PageTreeCoordinator), {
        // CONFCLOUD-69158 The key here is forcing page tree to re-mount when switching from space to space
        // This preventing issue when transition from a space that has homepage to a space without
        key: spaceKey,
        statuses: statusesRef.current,
        isPeekingFromBlogs: isPeekingFromBlogs,
        onPageMove: onPageMove,
        onDragStart: onDragStart,
        onMoveInvalid: onMoveInvalid,
        onLoadError: onLoadError,
        onExpand: expandAnalyticsCallback,
        onCollapse: collapseAnalyticsCallback,
        onLoadMore: onLoadMore,
        onInitialLoadComplete: onInitialLoadComplete,
        currentPageId: currentPageId,
        highlightPages: pageTreeStateUpdatesContainer.state.highlightPagesIds,
        forceFetchCurrentPage: Boolean(pageTreeStateUpdatesContainer.state.forceFetchPageId),
        forceFetchedCallback: forceFetchedCallback,
        optimisticDeleteId: pageTreeStateUpdatesContainer.state.optimisticDeletePageId || undefined,
        clearDeleteId: clearDelete,
        spaceKey: spaceKey,
        renderItem: renderItem,
        dragPreview: dragPreview,
        isDraggable: isDraggable,
        setIsPageTreeLoading: setIsPageTreeLoading,
        isSuperAdmin: isSuperAdmin,
        getIsDraggingItem: getIsDraggingItem,
        setIsDraggingItem: setIsDraggingItem,
        setOpenQuickActionsId: setOpenQuickActionsId,
        renderResourcedEmoji: renderResourcedEmoji.current,
        setContentTreeSize: setContentTreeSize,
        pageTreeStateUpdatesContainer: pageTreeStateUpdatesContainer,
        isCreateContentRoute: isCreateContentRoute,
        flags: flags
    }), (initialLoadComplete || undefined) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b8XTE.PageSegmentLoadEnd), {
        metric: (0, $1q7H7.PAGE_TREE_METRIC),
        customData: {
            initialPageTreeSize: initialPageTreeSize,
            skipTreeRenderSSR: !pageTreeWasSSRRendered //tracks if Best effort failed & if tree was over 200 pages
        },
        stopTime: pageTreeWasSSRRendered ? (0, $9eE57.getMark)('CFP-63.ssr-ttr') : undefined
    })));
};
const $a4f80453e05e0dd2$export$73500bf5f2e2b0c4 = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV1)() ? (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            (0, $gqqjz.FlagsStateContainer)
        ];
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).DISCO
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t0
        }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $7xVCs.PageTreeStateUpdater)
                ]
            }, (pageTreeStateUpdatesContainer)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a4f80453e05e0dd2$var$PageTreeInner, {
                    ...props,
                    pageTreeStateUpdatesContainer: pageTreeStateUpdatesContainer,
                    flags: flags
                }))));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $7xVCs.PageTreeStateUpdater)
            ]
        }, (pageTreeStateUpdatesContainer)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a4f80453e05e0dd2$var$PageTreeInner, {
                ...props,
                pageTreeStateUpdatesContainer: pageTreeStateUpdatesContainer,
                flags: flags
            });
        })));
});
$a4f80453e05e0dd2$export$73500bf5f2e2b0c4.displayName = 'PageTree';
module.exports["PageTree"] = $a4f80453e05e0dd2$export$73500bf5f2e2b0c4;

});

parcelRegister("kQ62s", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f2bd591dc7dccf33$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $f2bd591dc7dccf33$var$baseFindIndex;

});

parcelRegister("cH0F8", function(module, exports) {

var $7hXu9 = parcelRequire("7hXu9");


var $42omo = parcelRequire("42omo");


var $04e9M = parcelRequire("04e9M");


var $6ggfK = parcelRequire("6ggfK");


var $iYrVi = parcelRequire("iYrVi");


var $a2hNG = parcelRequire("a2hNG");

const $99b9dc495b87cac6$export$2fc805631456aefd = ()=>{
    const client = (0, $7hXu9.useApolloClient)();
    const { sendEvent: sendEvent } = (0, $6ggfK.useSendAnalyticsEvents)();
    const dwellTimeHelperRef = (0, $42omo.useRef)(null);
    const sendErrorEvent = (0, $42omo.useCallback)((errorMessage, data)=>{
        const unifiedErrorEvent = (0, $a2hNG.createConsumptionErrorEvent)(errorMessage, data);
        sendEvent(unifiedErrorEvent);
    }, [
        sendEvent
    ]);
    const sendInitiatedEvent = (0, $42omo.useCallback)((data, contentAttributesOverride)=>{
        (0, $iYrVi.loadSpaceAndContentData)(client, data.spaceKey, data.contentId).then((response)=>{
            const event = (0, $a2hNG.createConsumptionInitiatedEvent)(response, data, contentAttributesOverride);
            sendEvent(event);
        }).catch((error)=>sendErrorEvent(error.message, data));
    }, [
        client,
        sendErrorEvent,
        sendEvent
    ]);
    const sendViewedEvent = (0, $42omo.useCallback)((data, contentAttributesOverride)=>{
        (0, $iYrVi.loadSpaceAndContentData)(client, data.spaceKey, data.contentId).then((response)=>{
            const event = (0, $a2hNG.createConsumptionViewedEvent)(response, data, contentAttributesOverride);
            sendEvent(event);
        }).catch((error)=>sendErrorEvent(error.message, data));
    }, [
        client,
        sendErrorEvent,
        sendEvent
    ]);
    const sendCompletedEvent = (0, $42omo.useCallback)((event, dwellTimeHelperData)=>{
        if (dwellTimeHelperData.attributes.finalDwellEvent) {
            const consumptionCompletedEvent = (0, $a2hNG.createConsumptionCompletedEvent)(event, dwellTimeHelperData, document.visibilityState);
            sendEvent(consumptionCompletedEvent, true);
        }
    }, [
        sendEvent
    ]);
    const sendViewedEventAndCompletedEvent = (0, $42omo.useCallback)((data, contentAttributesOverride)=>{
        const sendEventPromise = (0, $iYrVi.loadSpaceAndContentData)(client, data.spaceKey, data.contentId).then((response)=>{
            const event = (0, $a2hNG.createConsumptionViewedEvent)(response, data, contentAttributesOverride);
            sendEvent(event);
            return event;
        });
        Promise.all([
            sendEventPromise,
            (0, $04e9M.getDwellTimeHelper)()
        ]).then(([event, DwellTimeHelper])=>{
            const dwellTimeHelper = new DwellTimeHelper((callbackData)=>sendCompletedEvent(event, callbackData), event.data);
            dwellTimeHelper.start();
            dwellTimeHelperRef.current = dwellTimeHelper;
        }).catch((error)=>{
            sendErrorEvent(error.message, data);
        });
    }, [
        client,
        sendEvent,
        sendCompletedEvent,
        sendErrorEvent
    ]);
    const stopDwellTimeTracker = (0, $42omo.useCallback)(()=>{
        if (dwellTimeHelperRef.current) dwellTimeHelperRef.current.stop();
    }, []);
    return {
        sendInitiatedEvent: sendInitiatedEvent,
        sendViewedEvent: sendViewedEvent,
        sendViewedEventAndCompletedEvent: sendViewedEventAndCompletedEvent,
        sendCompletedEvent: sendCompletedEvent,
        sendErrorEvent: sendErrorEvent,
        stopDwellTimeTracker: stopDwellTimeTracker
    };
};
module.exports["useConsumptionEvents"] = $99b9dc495b87cac6$export$2fc805631456aefd;

});

parcelRegister("6ggfK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $37a7b14bbef74679$export$ba826f94d4d18f90 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sendEvent = (0, $42omo.useCallback)((event, skipVisibilityCheck = false)=>{
        if (document.visibilityState === 'hidden' && !skipVisibilityCheck) document.addEventListener('visibilitychange', ()=>{
            if (document.visibilityState === 'visible') createAnalyticsEvent(event).fire();
        }, {
            once: true
        });
        else createAnalyticsEvent(event).fire();
    }, [
        createAnalyticsEvent
    ]);
    return {
        sendEvent: sendEvent
    };
};
module.exports["useSendAnalyticsEvents"] = $37a7b14bbef74679$export$ba826f94d4d18f90;

});

parcelRegister("iYrVi", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");

const $515f7b87fcfa6100$export$22490ad3617f1d6c = async (client, spaceKey, contentId)=>{
    if (!contentId) return Promise.reject(new Error('Content ID is required'));
    const response = await client.query({
        query: (0, $eSUdr.default)`query getConsumptionEventDataQuery($spaceKey:String!$contentId:ID!){space(key:$spaceKey){id type status}singleContent(id:$contentId){id status type subType}}`,
        variables: {
            spaceKey: spaceKey,
            contentId: contentId
        }
    });
    // this is a workaround to handle the case where the content is restricted
    if (!response.errors && response.data.singleContent === null) return Promise.reject('singleContent is null');
    return response;
};
module.exports["loadSpaceAndContentData"] = $515f7b87fcfa6100$export$22490ad3617f1d6c;

});

parcelRegister("a2hNG", function(module, exports) {
const $d12dabfe6ca737c1$export$1931aa92cd9ee803 = (status, contentState)=>{
    if (contentState) return contentState;
    switch(status){
        case 'current':
            return 'published';
        case 'archived':
            return 'archived';
        case 'draft':
            return 'draft';
        default:
            return 'unset';
    }
};
const $d12dabfe6ca737c1$export$3f4d5492ecb52ee5 = (subType, contentMode)=>{
    if (contentMode) return contentMode;
    switch(subType){
        case 'live':
            return 'live';
        case 'embed':
            return 'embedded';
        default:
            return 'classic';
    }
};
const $d12dabfe6ca737c1$export$5e059cd6f8a921d7 = (type, contentType)=>{
    if (contentType) return contentType;
    switch(type){
        case 'page':
            return 'page';
        case 'blogpost':
            return 'blogpost';
        case 'whiteboard':
            return 'whiteboard';
        case 'database':
            return 'database';
        case 'embed':
            return 'smartlink';
        default:
            return 'unset';
    }
};
const $d12dabfe6ca737c1$export$6d76e0936bf44cc2 = (response, data, contentAttributesOverride)=>{
    const contentType = $d12dabfe6ca737c1$export$5e059cd6f8a921d7(response?.data?.singleContent?.type, contentAttributesOverride?.contentType);
    const contentState = $d12dabfe6ca737c1$export$1931aa92cd9ee803(response?.data?.singleContent?.status, contentAttributesOverride?.contentState);
    const contentMode = $d12dabfe6ca737c1$export$3f4d5492ecb52ee5(response?.data?.singleContent?.subType, contentAttributesOverride?.contentMode);
    return {
        type: 'sendTrackEvent',
        data: {
            action: 'viewed',
            actionSubject: 'consumption',
            actionSubjectId: 'client',
            source: data.source,
            attributes: {
                contentType: contentType,
                contentMode: contentMode,
                contentState: contentState,
                spaceId: response?.data.space?.id ?? 'unset',
                contentId: response?.data.singleContent?.id ?? 'unset'
            }
        }
    };
};
const $d12dabfe6ca737c1$export$b4ddea3e5241109a = (response, data, contentAttributesOverride)=>{
    const contentType = $d12dabfe6ca737c1$export$5e059cd6f8a921d7(response?.data?.singleContent?.type, contentAttributesOverride?.contentType);
    const contentState = $d12dabfe6ca737c1$export$1931aa92cd9ee803(response?.data?.singleContent?.status, contentAttributesOverride?.contentState);
    const contentMode = $d12dabfe6ca737c1$export$3f4d5492ecb52ee5(response?.data?.singleContent?.subType, contentAttributesOverride?.contentMode);
    return {
        type: 'sendTrackEvent',
        data: {
            action: 'initiated',
            actionSubject: 'consumption',
            actionSubjectId: 'client',
            source: data.source,
            attributes: {
                contentType: contentType,
                contentMode: contentMode,
                contentState: contentState,
                spaceId: response?.data.space?.id ?? 'unset',
                contentId: response?.data.singleContent?.id ?? 'unset',
                utmSource: data.utmSource
            }
        }
    };
};
const $d12dabfe6ca737c1$export$ea5bf29fc7b309b8 = (event, dwellTimeHelperData, visibilityState)=>{
    return {
        type: 'sendTrackEvent',
        data: {
            ...event.data,
            action: 'completed',
            attributes: {
                ...event.data.attributes,
                dwellTime: dwellTimeHelperData.attributes.dwellTime,
                pageVisibility: visibilityState
            }
        }
    };
};
const $d12dabfe6ca737c1$export$b2d32ef04e5142a1 = (errorMessage, props)=>{
    return {
        type: 'sendTrackEvent',
        data: {
            action: 'error',
            actionSubject: 'consumption',
            actionSubjectId: 'client',
            source: props.source,
            attributes: {
                error: errorMessage,
                contentId: props.contentId ?? 'unset',
                spaceKey: props.spaceKey
            }
        }
    };
};
module.exports["createConsumptionViewedEvent"] = $d12dabfe6ca737c1$export$6d76e0936bf44cc2;
module.exports["createConsumptionInitiatedEvent"] = $d12dabfe6ca737c1$export$b4ddea3e5241109a;
module.exports["createConsumptionCompletedEvent"] = $d12dabfe6ca737c1$export$ea5bf29fc7b309b8;
module.exports["createConsumptionErrorEvent"] = $d12dabfe6ca737c1$export$b2d32ef04e5142a1;

});

parcelRegister("e4o8D", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $2679ebd914f0a083$export$96e8e9e8e57310bb = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const renderServerPlaceholderOnNonHydrate = t0 === undefined ? false : t0;
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setRenderServerPlaceholder(false);
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    return renderServerPlaceholder;
} : (renderServerPlaceholderOnNonHydrate = false)=>{
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    !isTransition || Boolean(undefined) : // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    (0, $42omo.useEffect)(()=>{
        setRenderServerPlaceholder(false);
    }, []);
    return renderServerPlaceholder;
};
module.exports["useRenderServerPlaceholder"] = $2679ebd914f0a083$export$96e8e9e8e57310bb;

});

parcelRegister("kVysQ", function(module, exports) {
const $35b50a968705ed01$export$9960fc620d4470dd = 'comments';
const $35b50a968705ed01$export$c4d483efe8eba686 = 'link-to-page';
const $35b50a968705ed01$export$1de09ba64e7728f2 = 'main-layout';
const $35b50a968705ed01$export$586856ecee8f0723 = 'manage-watcher-dialog';
const $35b50a968705ed01$export$51f018e0f9f84a74 = 'Navigation';
const $35b50a968705ed01$export$94afb8303c61d07d = 'navigation-fmp';
const $35b50a968705ed01$export$fe596581250cd9fc = 'side-navigation-fmp';
const $35b50a968705ed01$export$88c949ed1e388f68 = 'NavigationView';
const $35b50a968705ed01$export$1a3cc5086fadf289 = 'recent-dropdown';
const $35b50a968705ed01$export$b35db70015797a33 = 'resolved-inline-comments-dialog';
const $35b50a968705ed01$export$5c78998b70cdff69 = 'copy-page-tree';
const $35b50a968705ed01$export$1167e4f56227df4c = 'space-directory';
module.exports["PERFORMANCE_SUBJECT_linkToPage"] = $35b50a968705ed01$export$c4d483efe8eba686;
module.exports["PERFORMANCE_SUBJECT_mainLayout"] = $35b50a968705ed01$export$1de09ba64e7728f2;
module.exports["PERFORMANCE_SUBJECT_manageWatcherDialog"] = $35b50a968705ed01$export$586856ecee8f0723;
module.exports["PERFORMANCE_SUBJECT_navigation"] = $35b50a968705ed01$export$51f018e0f9f84a74;
module.exports["PERFORMANCE_SUBJECT_navigationFMP"] = $35b50a968705ed01$export$94afb8303c61d07d;
module.exports["PERFORMANCE_SUBJECT_sideNavigationFMP"] = $35b50a968705ed01$export$fe596581250cd9fc;
module.exports["PERFORMANCE_SUBJECT_navigationView"] = $35b50a968705ed01$export$88c949ed1e388f68;
module.exports["PERFORMANCE_SUBJECT_recentDropdown"] = $35b50a968705ed01$export$1a3cc5086fadf289;
module.exports["PERFORMANCE_SUBJECT_resolvedInlineCommentsDialog"] = $35b50a968705ed01$export$b35db70015797a33;
module.exports["PERFORMANCE_SUBJECT_copyPageTree"] = $35b50a968705ed01$export$5c78998b70cdff69;
module.exports["PERFORMANCE_SUBJECT_spaceDirectory"] = $35b50a968705ed01$export$1167e4f56227df4c;

});

parcelRegister("6GD8y", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2944f0e1873f71ce$export$90839ff33b4905a0 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pU1rv",
    name: "GeneralShortcutListener",
    loader: async ()=>(await (parcelRequire("9Q4ck"))).GeneralShortcutListener
});
module.exports["GeneralShortcutListener"] = $2944f0e1873f71ce$export$90839ff33b4905a0;

});

parcelRegister("9Q4ck", function(module, exports) {

let $729c39fbd06cc51d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $729c39fbd06cc51d$var$load("fZt2F"),
    $729c39fbd06cc51d$var$load("hhss7"),
    $729c39fbd06cc51d$var$load("kpHRm")
]).then(()=>parcelRequire('3w3bV'));

});

parcelRegister("gnkil", function(module, exports) {
// Note: When modifying shortcut settings, make sure to test across all input fields on the page.
// Some input fields may not have shortcuts fully disabled, which could cause conflicts with shortcuts.
// Ensure that the new shortcuts do not interfere with normal input field operations.
// When making change in this file, make sure the corresponding tab in @confluence/keyboard-shortcuts-dialog is also updated
// Shortcuts for editor2
const $e13bb5c64c0a0eec$export$170fefa3f8a9258a = {
    PUBLISH: 'mod+enter',
    PUBLISH_WITH_COMMENT: 'mod+shift+enter',
    EDIT: 'e',
    PREVIEW: 'mod+shift+e',
    UNDO: 'mod+z',
    REDO: 'mod+shift+z',
    FIND_REPLACE: 'mod+f'
};
const $e13bb5c64c0a0eec$export$1cbe44c5850db728 = 'mod+s';
const $e13bb5c64c0a0eec$export$73148f05a63f43f = 'command+enter';
const $e13bb5c64c0a0eec$export$67c56ed34ece0f2a = 'mod+enter';
const $e13bb5c64c0a0eec$export$c19d729632cce38f = 'b';
const $e13bb5c64c0a0eec$export$e896f39257754358 = 'c';
const $e13bb5c64c0a0eec$export$c9d367283380f242 = 'f';
const $e13bb5c64c0a0eec$export$44da7c32f8b979f6 = 'm';
const $e13bb5c64c0a0eec$export$f10fe393178b1b45 = 'k';
const $e13bb5c64c0a0eec$export$3837d28de95f38e = 'e';
const $e13bb5c64c0a0eec$export$99088c948bf0270f = 'r';
const $e13bb5c64c0a0eec$export$ddb528ae2130e6f3 = 'w';
const $e13bb5c64c0a0eec$export$95a205588c16f013 = 's';
const $e13bb5c64c0a0eec$export$f7fab4391dadca28 = 'l';
const $e13bb5c64c0a0eec$export$2f62883c954429eb = 't';
const $e13bb5c64c0a0eec$export$96f161bee6b4340d = 'n';
const $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172 = 'p';
const $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031 = 'g f';
const $e13bb5c64c0a0eec$export$b947af6524920798 = 'g g';
const $e13bb5c64c0a0eec$export$53e346b715d2b7c7 = 'g d';
const $e13bb5c64c0a0eec$export$8cb32cdc75719ad2 = 'g n';
const $e13bb5c64c0a0eec$export$b4842d8ad92c38a3 = 'g r';
const $e13bb5c64c0a0eec$export$298e62593d4ef85 = 'g s';
const $e13bb5c64c0a0eec$export$5d4720de35488ecb = 'g s';
const $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7 = 'g o';
const $e13bb5c64c0a0eec$export$f5473855a7a167a7 = 'g c';
const $e13bb5c64c0a0eec$export$cee4257b1a828f0d = '/';
const $e13bb5c64c0a0eec$export$159e447a25b21930 = '[';
const $e13bb5c64c0a0eec$export$922297bddc2a63e6 = 'mod+z';
const $e13bb5c64c0a0eec$export$420825475f86fe8d = 'left';
const $e13bb5c64c0a0eec$export$db9252a2db2b8e9e = 'right';
const $e13bb5c64c0a0eec$export$faa4136cec2aa7a0 = '?';
const $e13bb5c64c0a0eec$export$362c0171844ea600 = 'a';
const $e13bb5c64c0a0eec$export$5d80e625aa457659 = ']';
const $e13bb5c64c0a0eec$export$cc9bab4159e8aec9 = 'e';
const $e13bb5c64c0a0eec$export$285e80cf6c078ba6 = 'mod+shift+e';
const $e13bb5c64c0a0eec$export$8d0081a3f70f258c = 'ctrl+.';
const $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14 = 'ctrl+,';
const $e13bb5c64c0a0eec$export$de4065c6a68e4031 = 'mod+option+c';
const $e13bb5c64c0a0eec$export$b5f3b4e8358360b3 = 'ctrl+shift+d';
const $e13bb5c64c0a0eec$export$9cee57908df99565 = 'ctrl+option+n';
const $e13bb5c64c0a0eec$export$b0a212f4fb6d9350 = 'mod+shift+u';
const $e13bb5c64c0a0eec$export$986cc862e5f6eec1 = 'mod+option+r';
const $e13bb5c64c0a0eec$export$d3b6b270c6770b4f = 'ctrl+option+r';
const $e13bb5c64c0a0eec$export$adb85b0fd79d17f8 = 'ctrl+]';
const $e13bb5c64c0a0eec$export$1822b04007c39b0c = 'mod+option+shift+b';
const $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99 = 'ctrl+option+c';
const $e13bb5c64c0a0eec$export$f5ba0af3c65d3125 = 'meta+alt+c';
const $e13bb5c64c0a0eec$export$c372eed375f60e68 = 'ctrl+shift+/';
const $e13bb5c64c0a0eec$export$406fcfa6807667 = 'ctrl+[';
const $e13bb5c64c0a0eec$export$4ec29504bd71f204 = 'ctrl+option+f';
const $e13bb5c64c0a0eec$export$4148526d63a5bc01 = 'mod+option+o';
const $e13bb5c64c0a0eec$export$b7088d9be4883093 = 'ctrl+option+z';
const $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c = 'alt+shift+z';
const $e13bb5c64c0a0eec$export$2bdd2e57d23976c4 = 'mod+option+h';
const $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899 = 'mod+option+g';
const $e13bb5c64c0a0eec$export$18a9bb0de7844bb6 = 'mod+option+8';
const $e13bb5c64c0a0eec$export$3fe2d0f3fe115364 = 'mod+option+v';
const $e13bb5c64c0a0eec$export$a3e38cca130cbc49 = 'mod+option+w';
const $e13bb5c64c0a0eec$export$a769ea2ac46f94da = 'ctrl+option+w';
const $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd = 'mod+option+s';
const $e13bb5c64c0a0eec$export$4bc8c55d04859f5a = 'ctrl+shift+i';
const $e13bb5c64c0a0eec$export$1f53991bf9b208a0 = 'ctrl+option+a';
const $e13bb5c64c0a0eec$export$650d7b87402f841f = 'ctrl+option+t';
const $e13bb5c64c0a0eec$export$dc2c2f2eed832016 = 'meta+alt+t';
const $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d = 'mod+.';
const $e13bb5c64c0a0eec$export$c252fe6b173dfad3 = 'ctrl+meta+.';
const $e13bb5c64c0a0eec$export$a1552937ff7cca64 = 'mod+option+k';
const $e13bb5c64c0a0eec$export$f7727b957c03a88b = 'mod+option+e';
const $e13bb5c64c0a0eec$export$f0043475aa91a151 = 'alt+meta+x';
module.exports["EDITOR2_SHORTCUTS"] = $e13bb5c64c0a0eec$export$170fefa3f8a9258a;
module.exports["BROWSER_SAVE_SHORTCUT"] = $e13bb5c64c0a0eec$export$1cbe44c5850db728;
module.exports["COMMENT_EDITOR_SHORTCUT"] = $e13bb5c64c0a0eec$export$73148f05a63f43f;
module.exports["INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$67c56ed34ece0f2a;
module.exports["BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$c19d729632cce38f;
module.exports["GLOBAL_CREATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$e896f39257754358;
module.exports["STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$c9d367283380f242;
module.exports["CREATE_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$44da7c32f8b979f6;
module.exports["LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f10fe393178b1b45;
module.exports["EDIT_SHORTCUT"] = $e13bb5c64c0a0eec$export$3837d28de95f38e;
module.exports["PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$99088c948bf0270f;
module.exports["WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddb528ae2130e6f3;
module.exports["SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$95a205588c16f013;
module.exports["LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7fab4391dadca28;
module.exports["VIEW_ATTACHMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$2f62883c954429eb;
module.exports["NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$96f161bee6b4340d;
module.exports["PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172;
module.exports["SUBMIT_FEEDBACK_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031;
module.exports["NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$b947af6524920798;
module.exports["GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$53e346b715d2b7c7;
module.exports["NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$8cb32cdc75719ad2;
module.exports["GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b4842d8ad92c38a3;
module.exports["GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$298e62593d4ef85;
module.exports["SPACE_OVERVIEW_SHORTCUT_NAV_3"] = $e13bb5c64c0a0eec$export$5d4720de35488ecb;
module.exports["SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7;
module.exports["AI_MATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f5473855a7a167a7;
module.exports["NAVIGATION_SLASH_SHORTCUT"] = $e13bb5c64c0a0eec$export$cee4257b1a828f0d;
module.exports["SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$159e447a25b21930;
module.exports["UNDO_SHORTCUT"] = $e13bb5c64c0a0eec$export$922297bddc2a63e6;
module.exports["PREV_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$420825475f86fe8d;
module.exports["NEXT_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$db9252a2db2b8e9e;
module.exports["HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$faa4136cec2aa7a0;
module.exports["AUTOMATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$362c0171844ea600;
module.exports["TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER"] = $e13bb5c64c0a0eec$export$5d80e625aa457659;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_EDIT"] = $e13bb5c64c0a0eec$export$cc9bab4159e8aec9;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_VIEW"] = $e13bb5c64c0a0eec$export$285e80cf6c078ba6;
module.exports["UNIVERSAL_NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$8d0081a3f70f258c;
module.exports["UNIVERSAL_PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14;
module.exports["UNIVERSAL_OPEN_COMMENT_EDITOR"] = $e13bb5c64c0a0eec$export$de4065c6a68e4031;
module.exports["UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT"] = $e13bb5c64c0a0eec$export$b5f3b4e8358360b3;
module.exports["UNIVERSAL_CREATE_NOTE_SHORTCUT"] = $e13bb5c64c0a0eec$export$9cee57908df99565;
module.exports["UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b0a212f4fb6d9350;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$986cc862e5f6eec1;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$d3b6b270c6770b4f;
module.exports["UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$adb85b0fd79d17f8;
module.exports["UNIVERSAL_BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$1822b04007c39b0c;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$f5ba0af3c65d3125;
module.exports["UNIVERSAL_HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$c372eed375f60e68;
module.exports["UNIVERSAL_SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$406fcfa6807667;
module.exports["UNIVERSAL_STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$4ec29504bd71f204;
module.exports["UNIVERSAL_NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$4148526d63a5bc01;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$b7088d9be4883093;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c;
module.exports["UNIVERSAL_GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$2bdd2e57d23976c4;
module.exports["UNIVERSAL_GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899;
module.exports["UNIVERSAL_GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$18a9bb0de7844bb6;
module.exports["UNIVERSAL_SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$3fe2d0f3fe115364;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$a3e38cca130cbc49;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$a769ea2ac46f94da;
module.exports["UNIVERSAL_SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd;
module.exports["UNIVERSAL_OPEN_DETAILS_PANEL_SHORTCUT"] = $e13bb5c64c0a0eec$export$4bc8c55d04859f5a;
module.exports["UNIVERSAL_LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$1f53991bf9b208a0;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$650d7b87402f841f;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$dc2c2f2eed832016;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$c252fe6b173dfad3;
module.exports["UNIVERSAL_LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$a1552937ff7cca64;
module.exports["UNIVERSAL_SELECT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7727b957c03a88b;
module.exports["UNIVERSAL_OPEN_DEVTOOLS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0043475aa91a151;

});

parcelRegister("id4ij", function(module, exports) {
function $21c1903a8ac50cbe$export$f25538161b7e9c17(element) {
    let top = element.offsetTop;
    while(element.offsetParent){
        element = element.offsetParent;
        top += element.offsetTop;
    }
    return top;
}
function $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container) {
    if (!element) return false;
    container = container || document.scrollingElement || document.body.parentNode;
    if (!container) return false;
    const height = element.offsetHeight;
    const top = $21c1903a8ac50cbe$export$f25538161b7e9c17(element);
    const containerTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(container) + container.scrollTop;
    const containerHeight = container.offsetHeight;
    return top >= containerTop && top + height <= containerTop + containerHeight;
}
function $21c1903a8ac50cbe$export$e41e80160bed5714(node) {
    // @ts-ignore
    if (!node || node === document) return null;
    const nodeStyle = window.getComputedStyle(node);
    if (node.scrollHeight > node.clientHeight && node.style.overflow !== 'hidden' && nodeStyle.overflow !== 'visible') return node;
    else return $21c1903a8ac50cbe$export$e41e80160bed5714(node.parentNode);
}
function $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2(element, container) {
    container = container || $21c1903a8ac50cbe$export$e41e80160bed5714(element);
    if (!element || !container || $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container)) return;
    container.scrollTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(element) - $21c1903a8ac50cbe$export$f25538161b7e9c17(container) - container.clientHeight / 2;
}
function $21c1903a8ac50cbe$export$abe5643cba19555f(element) {
    return element.getBoundingClientRect();
}
function $21c1903a8ac50cbe$export$4c0864c7defafad3(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top, bottom: bottom } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    const bottomIsVisible = 0 <= bottom && bottom <= viewportHeight;
    const isBiggerThanViewPort = top <= 0 && 0 <= bottom && bottom >= viewportHeight;
    return topIsVisible || bottomIsVisible || isBiggerThanViewPort;
}
function $21c1903a8ac50cbe$export$4acade851e875ad4(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    return topIsVisible;
}
function $21c1903a8ac50cbe$export$5513bf0589d602a4(targetDomElementId, htmlMarkup) {
    let el = document.getElementById(targetDomElementId);
    if (!el) {
        el = document.createElement('div');
        el.setAttribute('id', targetDomElementId);
        el.setAttribute('style', 'display: none');
        document.body.appendChild(el);
        el = document.getElementById(targetDomElementId);
    }
    if (!el) return;
    el.innerHTML = '';
    if (htmlMarkup) {
        const range = document.createRange();
        const fragment = range.createContextualFragment(htmlMarkup);
        el.appendChild(fragment);
    }
}
module.exports["getElementTop"] = $21c1903a8ac50cbe$export$f25538161b7e9c17;
module.exports["isElementInViewport"] = $21c1903a8ac50cbe$export$7cc0e9dd2435cb30;
module.exports["scrollElementToViewCenter"] = $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2;
module.exports["getElementBounds"] = $21c1903a8ac50cbe$export$abe5643cba19555f;
module.exports["isPartOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4c0864c7defafad3;
module.exports["isTopOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4acade851e875ad4;
module.exports["replaceDomElementContent"] = $21c1903a8ac50cbe$export$5513bf0589d602a4;

});

parcelRegister("lpPVE", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $71GjD = parcelRequire("71GjD");

const $d9de10c6417158bd$export$d347e131abf45bea = (href, featureCodes)=>{
    if (!featureCodes.length) return href;
    const [path, queryString] = href.split('?');
    const searchParams = new URLSearchParams(queryString);
    // If the query param already exists, append the new feature codes to the existing ones
    if (searchParams.has((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) {
        const existingFeatureCodes = searchParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM)) || '';
        const newFeatureCodes = [
            ...new Set([
                ...existingFeatureCodes.split(','),
                ...featureCodes
            ])
        ];
        searchParams.set((0, $71GjD.FEATURE_CODES_QUERY_PARAM), newFeatureCodes.join(','));
    } else searchParams.append((0, $71GjD.FEATURE_CODES_QUERY_PARAM), featureCodes.join(','));
    const newQueryString = searchParams.toString();
    return newQueryString ? `${path}?${newQueryString}` : path;
};
const $d9de10c6417158bd$export$3c2127388df02347 = (queryParams)=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_insights_feature_attribution')) return {
        from: undefined
    };
    const featureCodes = queryParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM))?.split(',');
    const fromCode = featureCodes?.find((code)=>Object.values((0, $71GjD.FeatureCode)).includes(code));
    return {
        from: fromCode
    };
};
const $d9de10c6417158bd$export$241f453208292937 = (history, location)=>{
    if (!location?.search?.includes((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) return;
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete((0, $71GjD.FEATURE_CODES_QUERY_PARAM));
    const search = searchParams.toString();
    history?.replace?.({
        ...location,
        search: search ? `?${search}` : ''
    });
};
const $d9de10c6417158bd$export$866aaa0a921ee13d = (existingFeatureCodes, featureCodeToCheck)=>{
    return existingFeatureCodes.includes(featureCodeToCheck);
};
const $d9de10c6417158bd$export$84f5742c2ddda28f = (existingFeatureCodes, featureCodeToAdd)=>{
    if ($d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToAdd)) return existingFeatureCodes;
    return [
        ...existingFeatureCodes,
        featureCodeToAdd
    ];
};
const $d9de10c6417158bd$export$f2b1b8a892016485 = (existingFeatureCodes, featureCodeToRemove)=>{
    if (!$d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToRemove)) return existingFeatureCodes;
    return existingFeatureCodes.filter((code)=>code !== featureCodeToRemove);
};
module.exports["generatePathWithFeatureCodesQueryParam"] = $d9de10c6417158bd$export$d347e131abf45bea;
module.exports["getFeatureCodes"] = $d9de10c6417158bd$export$3c2127388df02347;
module.exports["hideFeatureCodesQueryParam"] = $d9de10c6417158bd$export$241f453208292937;

});

parcelRegister("71GjD", function(module, exports) {
/**
 * Feature attribution enum for tracking feature usage/attribution
 *
 * @note All feature codes are intended to be 8 characters or less in length
 *
 * @see https://hello.atlassian.net/wiki/x/lQxt9Q
 */ var $9d2fac30cbee1d6f$export$661babcb078ff919 = /*#__PURE__*/ function(FeatureCode) {
    /** Confluence Home Feeds (Following and Popular) **/ FeatureCode["HOME_FEED"] = "HOMEFEED";
    /** Confluence End of Page Recommendations (Related Pages) **/ FeatureCode["EOP_REC"] = "EOPREC";
    /** Confluence End of Page Recommendations (Related Pages) Hover Card **/ FeatureCode["EOP_REC_CARD"] = "EOPCARD";
    /** Confluence Page Tree **/ FeatureCode["PAGE_TREE"] = "PAGETREE";
    /** Confluence Page Tree Card **/ FeatureCode["PAGE_TREE_CARD"] = "TREECARD";
    /** Following Feed email **/ FeatureCode["FOLLOWING_FEED_EMAIL"] = "FLLWEML";
    /** Popular Feed email **/ FeatureCode["POPULAR_FEED_EMAIL"] = "PPLREML";
    FeatureCode["ADMIN_KEY_EMAIL"] = "ADMINEML";
    FeatureCode["ATTACHMENT_EMAILS"] = "ATTCHEML";
    FeatureCode["BATCH_EMAIL"] = "BATCHEML";
    FeatureCode["BLOG_CREATED_EMAIL"] = "BLOGEML";
    FeatureCode["BULK_ARCHIVE_EMAIL"] = "BLKAREML";
    FeatureCode["BULK_OWNER_CHANGE_EMAIL"] = "BLKOWEML";
    FeatureCode["CONFLUENCE_WRAPPED_EMAIL"] = "WRAPEML";
    FeatureCode["CONTACT_ADMINISTRATORS_EMAIL"] = "CTADMEML";
    FeatureCode["CONTENT_OWNER_CHANGE_EMAIL"] = "OWNREML";
    FeatureCode["CONTENT_REDACTION_EMAIL"] = "RDCTDEML";
    FeatureCode["EXCO_ADDED_TO_SPACE_EMAIL"] = "EXCASEML";
    FeatureCode["EXCO_REQUEST_ACCESS_EMAIL"] = "EXCRAEML";
    FeatureCode["EXCO_SPACE_READY_EMAIL"] = "EXCSREML";
    FeatureCode["IMPORTER_NOTIFICATIONS"] = "IMPRTNTF";
    FeatureCode["LIVE_PAGE_PUBLISHED_EMAIL"] = "LPPEML";
    FeatureCode["MENTIONS_EMAIL"] = "MNTNEML";
    FeatureCode["PAGE_CREATED_EMAIL"] = "PAGEEML";
    FeatureCode["REMINDER_EMAIL"] = "RMNDREML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_EMAILS"] = "REQACEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_SLACK"] = "REQACSLK";
    FeatureCode["TASKS_EMAIL"] = "TASKEML";
    FeatureCode["TEAM_CALENDAR_EMAIL"] = "CLNDREML";
    FeatureCode["WHITEBOARD_CREATED_EMAIL"] = "WTBRDEML";
    FeatureCode["CONTENT_REDACTION_IN_APP"] = "RDCTDAPP";
    FeatureCode["DAILY_DIGEST_EMAIL"] = "DIGSTEML";
    FeatureCode["MENTIONS_REMINDER_EMAIL"] = "MNTNREML";
    FeatureCode["PUBLIC_LINK_EMAIL"] = "PBLNKEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_IN_APP"] = "REQACAPP";
    FeatureCode["SHARE_AND_RESTRICT_DIALOG"] = "SRDIALOG";
    FeatureCode["ROVO_CHAT_LINK"] = "ROVOCHAT";
    FeatureCode["ROVO_EXTENSION_LINK"] = "ROVOEXT";
    return FeatureCode;
}({});
const $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd = 'atl_f';
const $9d2fac30cbee1d6f$export$384cf7f2010cb469 = 'confluence_frontend_insights_feature_attribution';
module.exports["FeatureCode"] = $9d2fac30cbee1d6f$export$661babcb078ff919;
module.exports["FEATURE_CODES_QUERY_PARAM"] = $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd;

});

parcelRegister("7xVCs", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $T1bCI = parcelRequire("T1bCI");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $T1bCI.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("b8XTE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $3kTfj = parcelRequire("3kTfj");


var $1NBp8 = parcelRequire("1NBp8");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");

const $eb0c119b7155e6d7$var$noop = ()=>{};
const $eb0c119b7155e6d7$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ customData: customData = {}, metric: metric, onComplete: onComplete = $eb0c119b7155e6d7$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete })=>{
    // Use refs to avoid firing handlePageSegmentLoadMetricStop more than once despite changes to stopTime or customData
    const stopTimeRef = (0, $42omo.useRef)(stopTime);
    const customDataRef = (0, $42omo.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $42omo.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handlePageSegmentLoadMetricStop = (0, $42omo.useCallback)(()=>{
        if (metric) {
            onComplete();
            let finalCustomData;
            if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
            else finalCustomData = customDataRef.current;
            const { route: route } = metric.getData();
            const shouldAddViewTransitionSource = route === (0, $1NBp8.VIEW_PAGE).name || route === (0, $1NBp8.VIEW_BLOG).name;
            if (shouldAddViewTransitionSource) finalCustomData.viewTransitionSource = (0, $lXYVJ.getViewTransitionSource)();
            (0, $3kTfj.browserMetrics).getPageLoadMetric().mark(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${metric.key}`);
            metric.stop({
                customData: {
                    ...finalCustomData,
                    previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
                    previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                },
                stopTime: stopTimeRef.current
            });
        }
    }, [
        metric,
        onComplete
    ]);
    (0, $N1nBh.usePerformanceAction)(handlePageSegmentLoadMetricStop, timing);
    return null;
}, /**
	 * Use lodash isEqual as comparator to avoid unnecessary re-renders
	 * i.e. when an object is defined directly within customData prop
	 * `<PageLoadSegmentEnd ... customData={{ data: 'example' }} />`
	 * (Export only for testing)
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $eb0c119b7155e6d7$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($eb0c119b7155e6d7$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $eb0c119b7155e6d7$export$a267cdf45880b07b;

});

parcelRegister("N1nBh", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
	 * This will perform the given action at a scheduled time after the
	 * component has painted.
	 *
	 * This is the default behavior.
	 */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
	 * This will perform the given action at the next animation frame (after the
	 * component has been painted).
	 */ ActionTiming["PAINT"] = "PAINT";
    /**
	 * This will perform the given action at the moment its render function
	 * fires.
	 *
	 * NOTE: This is called _within_ the render body, making it unpure. The
	 * component is memoized, so it will fire this only once for a given set
	 * of props. Be careful when using this, since it is unsafe.
	 */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $42omo.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $42omo.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["RECENT_DROPDOWN_ITEM_CLICK"] = $f3fed16e32582dfc$export$e20b00d7fdb37fd5;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("7d2Nc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3kTfj = parcelRequire("3kTfj");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");

const $c2bdb1677e0a2d6c$var$noop = ()=>{};
const $c2bdb1677e0a2d6c$var$PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $42omo.memo)(({ metric: metric, onComplete: onComplete = $c2bdb1677e0a2d6c$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY, isCustomStart: isCustomStart = false })=>{
    const handlePageLoadMetricStart = (0, $42omo.useCallback)(()=>{
        if (metric) {
            (0, $3kTfj.browserMetrics).getPageLoadMetric().mark(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${metric.key}`);
            if (isCustomStart) metric.start();
            else metric.startFromPageLoad();
            onComplete();
        }
    }, [
        metric,
        onComplete,
        isCustomStart
    ]);
    (0, $N1nBh.usePerformanceAction)(handlePageLoadMetricStart, timing);
    return null;
});
const $c2bdb1677e0a2d6c$export$f11db193fdaffcc9 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($c2bdb1677e0a2d6c$var$PageSegmentLoadStartComponent);
module.exports["PageSegmentLoadStart"] = $c2bdb1677e0a2d6c$export$f11db193fdaffcc9;

});

parcelRegister("huWyw", function(module, exports) {

var $jlIaF = parcelRequire("jlIaF");

const $61f50eb1c9d5c417$export$35f6369946b1d8c9 = ({ url: url, spaceKey: spaceKey, contentType: contentType, editorVersion: editorVersion, contentId: contentId, fabricEditorSupported: fabricEditorSupported, noContextPath: noContextPath })=>{
    const isPage = contentType === 'page';
    const isBlog = contentType === 'blogpost';
    const isPageOrBlog = isPage || isBlog;
    const isUsingFabricEditor = fabricEditorSupported || editorVersion === 'v2'; // as opposed to the v1 TinyMCE editor
    const providedURLHitsResumeDraftAction = url.includes('resumedraft.action');
    if (isPageOrBlog && isUsingFabricEditor && providedURLHitsResumeDraftAction) {
        const contentTypeForURL = isPage ? 'pages' : 'blog';
        const contentIdForURL = contentId;
        // Extract the query string from the relative URL.
        const queryString = url.includes('?') ? url.slice(url.indexOf('?') + 1) : '';
        // Extract the `draftShareId` from the query string.
        const urlSearchParams = new URLSearchParams(queryString);
        const draftShareId = urlSearchParams.get('draftShareId');
        const draftShareIdParamString = draftShareId ? `draftShareId=${draftShareId}` : '';
        const optionalContextPath = noContextPath ? '' : (0, $jlIaF.CONTEXT_PATH);
        const bypassURL = `${optionalContextPath}/spaces/${spaceKey}/${contentTypeForURL}/edit-v2/${contentIdForURL}?${draftShareIdParamString}`;
        return bypassURL;
    } else return url;
};
module.exports["getURLBypassingResumeDraftAction"] = $61f50eb1c9d5c417$export$35f6369946b1d8c9;

});

parcelRegister("de2j9", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
} : ()=>(0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("lqy4C", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4c1VG = parcelRequire("4c1VG");


var $alLTz = parcelRequire("alLTz");


var $cLhhP = parcelRequire("cLhhP");

const $047fd93b8f400f5d$export$5419ac0b96bac54b = ({ source: source })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    const { isStorageEnforcementGracePeriodComplete: isStorageEnforcementGracePeriodComplete } = (0, $4c1VG.useGetCurrentStorageUsage)({
        skip: !isEligibleUser
    });
    const { showBlockCreateModal: showBlockCreateModal } = (0, $cLhhP.useBlockCreateModalActions)();
    const shouldBlockCreate = isEligibleUser && Boolean(isStorageEnforcementGracePeriodComplete);
    const enforceStorageLimit = (0, $42omo.useCallback)((callback)=>(...args)=>{
            if (shouldBlockCreate) {
                // If the callback is a DOM event (e.g. click, keydown/keyup)
                // handler, prevent the default action (e.g. navigating to an href):
                const event = args?.[0];
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                experienceTracker.start({
                    name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'render',
                        actionSubject: 'hardStorageEnforcement',
                        actionSubjectId: 'enforceStorageLimit',
                        source: source || 'onboarding'
                    }
                }).fire();
                showBlockCreateModal(source);
                return;
            }
            return callback.apply(undefined, args);
        }, [
        createAnalyticsEvent,
        experienceTracker,
        shouldBlockCreate,
        showBlockCreateModal,
        source
    ]);
    return {
        shouldBlockCreate: shouldBlockCreate,
        enforceStorageLimit: enforceStorageLimit
    };
};
module.exports["useHardStorageEnforcement"] = $047fd93b8f400f5d$export$5419ac0b96bac54b;

});

parcelRegister("4c1VG", function(module, exports) {

var $1hmAp = parcelRequire("1hmAp");


var $jMyy4 = parcelRequire("jMyy4");

const $1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery = (0, $1hmAp.default);
const $1f652a8c0a42982a$export$8bf54c39c48ff2d2 = ({ skip: skip } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery, {
        skip: skip
    });
    return {
        currentUsage: data?.storage?.bytesUsed ?? 0,
        isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
        gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
        loading: loading,
        error: error
    };
};
module.exports["useGetCurrentStorageUsage"] = $1f652a8c0a42982a$export$8bf54c39c48ff2d2;

});

parcelRegister("1hmAp", function(module, exports) {
/**
 * @generated SignedSource<<634d8ca034d2498a989d5a4ffee872da>>
 * @relayHash 70e80297d041fb31c0639d661a01c799
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54
const $dc4c6b557b36d823$var$node = function() {
    var v0 = [
        {
            "alias": "storage",
            "concreteType": "ConfluenceStorage",
            "kind": "LinkedField",
            "name": "confluence_storage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "bytesUsed"
                },
                {
                    "kind": "ScalarField",
                    "name": "isStorageEnforcementGracePeriodComplete"
                },
                {
                    "kind": "ScalarField",
                    "name": "gracePeriodEndDate"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "70e80297d041fb31c0639d661a01c799",
            "id": "6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54",
            "metadata": {},
            "name": "useGetCurrentStorageUsageQuery",
            "operationKind": "query",
            "text": "query useGetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed,isStorageEnforcementGracePeriodComplete,gracePeriodEndDate}}"
        }
    };
}();
$dc4c6b557b36d823$var$node.hash = "41d2bf41d832c3866355b26b49942948";
var $dc4c6b557b36d823$export$2e2bcd8739ae039 = $dc4c6b557b36d823$var$node;
module.exports["default"] = $dc4c6b557b36d823$export$2e2bcd8739ae039;

});

parcelRegister("alLTz", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");

const $2f3a7af74886cca0$export$3fc4fcb674af9bce = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isEligibleUser = edition === (0, $euL71.ConfluenceEdition).FREE && isLoggedIn;
    return isEligibleUser;
};
module.exports["useIsStorageEnforcementEligible"] = $2f3a7af74886cca0$export$3fc4fcb674af9bce;

});

parcelRegister("cLhhP", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $ff89d2fd8e30c2ae$var$initialState = {
    isActive: false,
    source: ''
};
const $ff89d2fd8e30c2ae$var$NAME = 'BLOCK_CREATE_MODAL_STORE';
const $ff89d2fd8e30c2ae$var$BlockCreateModalStore = (0, $1P1Tu.createStore)({
    name: $ff89d2fd8e30c2ae$var$NAME,
    initialState: $ff89d2fd8e30c2ae$var$initialState,
    actions: {
        showBlockCreateModal: (source)=>({ setState: setState })=>{
                setState({
                    isActive: true,
                    source: source
                });
            },
        onBlockCreateModalClose: ()=>({ setState: setState })=>{
                setState({
                    isActive: false,
                    source: ''
                });
            }
    }
});
const $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc = (0, $9zUhf.createHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
const $ff89d2fd8e30c2ae$export$d0e21e34c085fe56 = (0, $9zUhf.createActionsHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
module.exports["useBlockCreateModalStore"] = $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc;
module.exports["useBlockCreateModalActions"] = $ff89d2fd8e30c2ae$export$d0e21e34c085fe56;

});

parcelRegister("d0oNo", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $4u5NT = parcelRequire("4u5NT");


var $9wGTI = parcelRequire("9wGTI");

const $120280a361e5f451$var$initialState = {
    active: false,
    nav4GlobalChangeboardingActive: false,
    nav4SpaceSettingsChangeboardingActive: false
};
const $120280a361e5f451$var$actions = {
    setActive: (active)=>({ setState: setState })=>{
            setState({
                active: active
            });
        },
    nav4GlobalChangeboardingActive: (nav4GlobalChangeboardingActive)=>({ setState: setState })=>{
            setState({
                nav4GlobalChangeboardingActive: nav4GlobalChangeboardingActive
            });
        },
    nav4SpaceSettingsChangeboardingActive: (nav4SpaceSettingsChangeboardingActive)=>({ setState: setState })=>{
            setState({
                nav4SpaceSettingsChangeboardingActive: nav4SpaceSettingsChangeboardingActive
            });
        }
};
const $120280a361e5f451$var$ModernizeChangeboardingStore = (0, $1P1Tu.createStore)({
    initialState: $120280a361e5f451$var$initialState,
    actions: $120280a361e5f451$var$actions
});
const $120280a361e5f451$export$6f50ba18fc24265e = (0, $9zUhf.createStateHook)($120280a361e5f451$var$ModernizeChangeboardingStore, {
    selector: (state)=>state.active
});
const $120280a361e5f451$export$8f3ba153b8f179a7 = (0, $9zUhf.createStateHook)($120280a361e5f451$var$ModernizeChangeboardingStore);
const $120280a361e5f451$var$useActions = (0, $9zUhf.createActionsHook)($120280a361e5f451$var$ModernizeChangeboardingStore);
const $120280a361e5f451$var$WithModernizeChangeboardingActiveComponent = ({ children: children, setActive: setActive })=>{
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_exclude_changeboarding_from_vc')) (0, $4u5NT.abortAll)('new_interaction', 'modernize-changeboarding');
        setActive(true);
        return ()=>{
            setActive(false);
        };
    }, [
        setActive
    ]);
    return children;
};
const $120280a361e5f451$export$e6009f28c745ed28 = ({ children: children })=>{
    const { setActive: setActive } = $120280a361e5f451$var$useActions();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($120280a361e5f451$var$WithModernizeChangeboardingActiveComponent, {
        setActive: setActive
    }, children);
};
const $120280a361e5f451$export$7ebbacbc785c02ee = ({ children: children })=>{
    const { nav4GlobalChangeboardingActive: nav4GlobalChangeboardingActive } = $120280a361e5f451$var$useActions();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($120280a361e5f451$var$WithModernizeChangeboardingActiveComponent, {
        setActive: nav4GlobalChangeboardingActive
    }, children);
};
const $120280a361e5f451$export$9955699a3aa2b6fa = ({ children: children })=>{
    const { nav4SpaceSettingsChangeboardingActive: nav4SpaceSettingsChangeboardingActive } = $120280a361e5f451$var$useActions();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($120280a361e5f451$var$WithModernizeChangeboardingActiveComponent, {
        setActive: nav4SpaceSettingsChangeboardingActive
    }, children);
};
module.exports["useModernizeChangeboardingActive"] = $120280a361e5f451$export$6f50ba18fc24265e;
module.exports["useModernizeChangeboardingState"] = $120280a361e5f451$export$8f3ba153b8f179a7;
module.exports["WithModernizeChangeboardingActive"] = $120280a361e5f451$export$e6009f28c745ed28;
module.exports["WithModernizeNav4GlobalChangeboardingActive"] = $120280a361e5f451$export$7ebbacbc785c02ee;
module.exports["WithModernizeNav4SpaceSettingsChangeboardingActive"] = $120280a361e5f451$export$9955699a3aa2b6fa;

});

parcelRegister("ivyMZ", function(module, exports) {
var $4eb170397cdf11a9$export$bcac0c74873fee96 = /*#__PURE__*/ function(GraphQLPageStatus) {
    GraphQLPageStatus["CURRENT"] = "CURRENT";
    GraphQLPageStatus["DRAFT"] = "DRAFT";
    return GraphQLPageStatus;
}({});
const $4eb170397cdf11a9$export$48ccce95f626ae31 = [
    "CURRENT",
    "DRAFT"
];
const $4eb170397cdf11a9$export$5522fe3493552101 = [
    'current',
    'draft'
];
module.exports["PAGE_TREE_STATUSES"] = $4eb170397cdf11a9$export$48ccce95f626ae31;

});

parcelRegister("5izcQ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $QiYCb = parcelRequire("QiYCb");


var $6cnUO = parcelRequire("6cnUO");

/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $f788f1551fff696f$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6cnUO.TargetConsumer), {
        children: (getTargetRef)=>{
            if (typeof children === 'function') return children({
                targetRef: getTargetRef?.(name)
            });
            return getTargetRef ? /*#__PURE__*/ (0, $l998X.jsx)((0, $QiYCb.default), {
                name: name,
                hasNodeResolver: !(0, $dh538.fg)('platform_design_system_team_onboarding_noderesolve'),
                getTargetRef: getTargetRef,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                    children: children
                })
            }) : children;
        }
    });
$f788f1551fff696f$var$SpotlightTarget.displayName = 'SpotlightTarget';
var $f788f1551fff696f$export$2e2bcd8739ae039 = $f788f1551fff696f$var$SpotlightTarget;
module.exports["default"] = $f788f1551fff696f$export$2e2bcd8739ae039;

});

parcelRegister("QiYCb", function(module, exports) {
/* node-resolver-spotlight-target.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $e8Hkv = parcelRequire("e8Hkv");

const $9a3edd35791f2369$var$spanStyles = null; /**
                          * A wrapper component that conditionally applies a NodeResolver to its children.
                          *
                          * Note: NodeResolver should not be used in React 18 concurrent mode. This component
                          * is intended to be removed once the feature flag  is removed.
                          * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
                          * @param {ReactElement} props.children - The child elements to be wrapped.
                          * @param {string} props.name - The name to reference from Spotlight.
                          * @param {ReactElement} props.getTargetRef - Setting up Target Node in Spotlight Manager.
                          * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
                          */ 
const $9a3edd35791f2369$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, getTargetRef: getTargetRef, name: name })=>{
    const divRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const targetRef = getTargetRef(name);
        if (!hasNodeResolver) targetRef(divRef.current?.firstElementChild);
        return ()=>{
            !hasNodeResolver && targetRef(undefined);
        };
    }, [
        hasNodeResolver,
        name,
        getTargetRef
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e8Hkv))), {
        innerRef: getTargetRef(name),
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ref: divRef,
        className: (0, $gMc0m.default)([
            "_1e0c1bgi"
        ]),
        children: children
    });
};
$9a3edd35791f2369$var$NodeResolverSpotlightTarget.displayName = 'NodeResolverSpotlightTarget';
var $9a3edd35791f2369$export$2e2bcd8739ae039 = $9a3edd35791f2369$var$NodeResolverSpotlightTarget;
module.exports["default"] = $9a3edd35791f2369$export$2e2bcd8739ae039;

});

parcelRegister("llP7S", function(module, exports) {

let $f8b337b9ca6757ac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f8b337b9ca6757ac$var$load("gODOu").then(()=>parcelRequire('CgYzk'));

});

parcelRegister("1q7H7", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jIOyV = parcelRequire("jIOyV");

var $jX1qB = parcelRequire("jX1qB");

const $108e3019fffb7b94$export$6e28125ef9389dc6 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.PAGE_TREE_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $108e3019fffb7b94$export$45b21bbf8961b519 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.MOVE_PAGE_DIALOG_INTERACTION)
});
module.exports["PAGE_TREE_METRIC"] = $108e3019fffb7b94$export$6e28125ef9389dc6;
module.exports["MOVE_PAGE_DIALOG_INTERACTION_METRIC"] = $108e3019fffb7b94$export$45b21bbf8961b519;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$eb06363d6ef3b8dd = 'restrictions-dialog';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["RESTRICTIONS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$eb06363d6ef3b8dd;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["VIEW_AI_PRESENTATION_INTERACTION"] = $4fa41f80373a2ebe$export$af1eb8557193d022;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$7416ef7ed24ec47f = 'media';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$fdd1a35fb559480a = 'recap-modal';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["MEDIA_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7416ef7ed24ec47f;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$687913e127f52cc3;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["RECAP_MODAL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$fdd1a35fb559480a;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;

});

parcelRegister("hQNhB", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $cfed858cac4ecf38$var$noop() {
// No operation performed.
}
module.exports = $cfed858cac4ecf38$var$noop;

});

parcelRegister("ghltV", function(module, exports) {

var $jcOUW = parcelRequire("jcOUW");


var $7LQYo = parcelRequire("7LQYo");


var $lkNSx = parcelRequire("lkNSx");


var $bcPN2 = parcelRequire("bcPN2");


var $eSSFf = parcelRequire("eSSFf");


var $fTWVK = parcelRequire("fTWVK");

/** Used as the size to enable large array optimizations. */ var $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $bd9ee5aa9be27a90$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $7LQYo, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $lkNSx;
    } else if (length >= $bd9ee5aa9be27a90$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $eSSFf(array);
        if (set) return $fTWVK(set);
        isCommon = false;
        includes = $bcPN2;
        seen = new $jcOUW;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $bd9ee5aa9be27a90$var$baseUniq;

});

parcelRegister("7LQYo", function(module, exports) {

var $gbGQI = parcelRequire("gbGQI");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $5a8603892d8b8e7a$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $gbGQI(array, value, 0) > -1;
}
module.exports = $5a8603892d8b8e7a$var$arrayIncludes;

});

parcelRegister("gbGQI", function(module, exports) {

var $kQ62s = parcelRequire("kQ62s");


var $4iBhD = parcelRequire("4iBhD");


var $9vdTF = parcelRequire("9vdTF");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bc8ee968e98dba2a$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $9vdTF(array, value, fromIndex) : $kQ62s(array, $4iBhD, fromIndex);
}
module.exports = $bc8ee968e98dba2a$var$baseIndexOf;

});

parcelRegister("4iBhD", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3215c39807e7891a$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $3215c39807e7891a$var$baseIsNaN;

});

parcelRegister("9vdTF", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6eb1c9efc79a544d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $6eb1c9efc79a544d$var$strictIndexOf;

});

parcelRegister("lkNSx", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $f882281822db2c99$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $f882281822db2c99$var$arrayIncludesWith;

});

parcelRegister("eSSFf", function(module, exports) {

var $l57m2 = parcelRequire("l57m2");


var $hQNhB = parcelRequire("hQNhB");


var $fTWVK = parcelRequire("fTWVK");

/** Used as references for various `Number` constants. */ var $ad608304180e5c8a$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $ad608304180e5c8a$var$createSet = !($l57m2 && 1 / $fTWVK(new $l57m2([
    ,
    -0
]))[1] == $ad608304180e5c8a$var$INFINITY) ? $hQNhB : function(values) {
    return new $l57m2(values);
};
module.exports = $ad608304180e5c8a$var$createSet;

});

parcelRegister("6a9Hv", function(module, exports) {

var $hWvFC = parcelRequire("hWvFC");


var $ghltV = parcelRequire("ghltV");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $47cb339bef10f9e0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ghltV(array, $hWvFC(iteratee, 2)) : [];
}
module.exports = $47cb339bef10f9e0$var$uniqBy;

});

parcelRegister("8jC8i", function(module, exports) {

var $hwwIB = parcelRequire("hwwIB");


var $ifqdW = parcelRequire("ifqdW");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $60ddad71e9a2305d$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $ifqdW);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $60ddad71e9a2305d$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hwwIB(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $60ddad71e9a2305d$var$baseFlatten;

});

parcelRegister("ifqdW", function(module, exports) {

var $agzqu = parcelRequire("agzqu");


var $dI6Ko = parcelRequire("dI6Ko");


var $fZxmY = parcelRequire("fZxmY");

/** Built-in value references. */ var $d48df83729a0e096$var$spreadableSymbol = $agzqu ? $agzqu.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $d48df83729a0e096$var$isFlattenable(value) {
    return $fZxmY(value) || $dI6Ko(value) || !!($d48df83729a0e096$var$spreadableSymbol && value && value[$d48df83729a0e096$var$spreadableSymbol]);
}
module.exports = $d48df83729a0e096$var$isFlattenable;

});

parcelRegister("fEmGS", function(module, exports) {

var $86okN = parcelRequire("86okN");

function $f0827a369f0dafa9$export$f97bd2548c77448c(params) {
    return $f0827a369f0dafa9$var$writeQueryInteropApollo(params);
}
function $f0827a369f0dafa9$var$writeQueryInteropRelay(params) {
    const relayEnv = window.GLOBAL_RELAY_ENV;
    const { query: query, data: data, variables: variables } = params;
    if (!data) return;
    relayEnv.commitUpdate((storeProxy)=>{
        const root = storeProxy.getRoot();
        if (!root) return;
        const queryNode = query;
        const queryFields = queryNode?.operation?.selections;
        if (queryFields) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, root, queryFields, data, variables || {});
    });
}
function $f0827a369f0dafa9$var$writeQueryFields(storeProxy, record, fields, data, variables) {
    if (!record || !data) return;
    for (const field of fields){
        if (field.kind === 'LinkedField') {
            const linkedField = field;
            const fieldData = data[linkedField.name];
            if (fieldData !== undefined) {
                if (Array.isArray(fieldData)) {
                    const linkedRecords = fieldData.map((item)=>{
                        if (item && typeof item === 'object') {
                            const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                            const existingRecord = record.getLinkedRecord(fieldKey);
                            if (existingRecord && linkedField.selections) {
                                $f0827a369f0dafa9$var$writeQueryFields(storeProxy, existingRecord, linkedField.selections, item, variables);
                                return existingRecord;
                            }
                        }
                        return null;
                    }).filter((rec)=>rec !== null);
                    if (linkedRecords.length > 0) {
                        const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                        record.setLinkedRecords(linkedRecords, fieldKey);
                    }
                } else if (fieldData && typeof fieldData === 'object') {
                    const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                    const linkedRecord = record.getLinkedRecord(fieldKey);
                    // If no linked record exists but we have data with an ID, we can try to get the existing record,
                    // or create a new record based on __typename. However, this shouldn't be a common use-case across the codebase,
                    // so we'll skip these code paths for now
                    if (linkedRecord && linkedField.selections) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, linkedRecord, linkedField.selections, fieldData, variables);
                }
            }
        } else if (field.kind === 'ScalarField') {
            const scalarField = field;
            if (data[scalarField.name] !== undefined) record.setValue(data[scalarField.name], scalarField.name);
        }
    }
}
function $f0827a369f0dafa9$var$getFieldKey(field, variables) {
    if (!field.args || field.args.length === 0) return field.name;
    // Compute storage key for fields with arguments
    const args = field.args.map((arg)=>{
        let value;
        if (arg.kind === 'Literal') value = JSON.stringify(arg.value);
        else if (arg.kind === 'Variable') value = JSON.stringify(variables[arg.variableName]);
        else // Fallback for other argument types
        value = JSON.stringify(arg.value);
        return `${arg.name}:${value}`;
    }).join(',');
    return `${field.name}(${args})`;
}
function $f0827a369f0dafa9$var$writeQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].writeQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["writeQueryInterop"] = $f0827a369f0dafa9$export$f97bd2548c77448c;

});

parcelRegister("l1uFv", function(module, exports) {

var $86okN = parcelRequire("86okN");

function $65c7b8940c778902$export$627cb922211284f(params) {
    return $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});

parcelRegister("7PLO8", function(module, exports) {
const $3009aa09d1bfedbe$export$93a0fdadbf6c055a = ()=>{
    return new URLSearchParams(window.location.search.substring(1)).get('draftShareId') || '';
};
module.exports["getDraftShareIdFromQueryParam"] = $3009aa09d1bfedbe$export$93a0fdadbf6c055a;

});

parcelRegister("1oGPE", function(module, exports) {
const $00840277cc5ce9b5$export$90091b93f6cf4241 = 80;
const $00840277cc5ce9b5$export$3cf9a7263d7d2d28 = 100; // INITIAL_PAGE_SIZE was previously 160 but we reduced it to 80. Should we also reduce this?
module.exports["INITIAL_PAGE_SIZE"] = $00840277cc5ce9b5$export$90091b93f6cf4241;
module.exports["CHILDREN_PAGE_SIZE"] = $00840277cc5ce9b5$export$3cf9a7263d7d2d28;

});

parcelRegister("inLKs", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $7ec1eb52421f9faa$export$8d5511a885429a32 = (0, $eSUdr.default)`query PageTreeQuery($spaceKey:String!$statuses:[GraphQLPageStatus]$ptStatuses:[PTGraphQLPageStatus]$contentId:ID!$paginationLimit:Int$isSuperAdmin:Boolean!$isReplacePagesWithPTPageEnabled:Boolean!=false){currentPage:ptpage(id:$contentId spaceKey:$spaceKey pageTree:$paginationLimit status:$ptStatuses enablePaging:true){id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}nearestAncestors{pageInfo{hasNextPage endCursor}nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}previousSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}followingSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}}}previousSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}followingSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}children{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}}ptpage(spaceKey:$spaceKey pageTree:$paginationLimit status:$ptStatuses enablePaging:true)@include(if:$isReplacePagesWithPTPageEnabled){id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}followingSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}}rootLevelPages:pages(spaceKey:$spaceKey status:$statuses)@skip(if:$isReplacePagesWithPTPageEnabled){nodes{id title status hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}}space(key:$spaceKey){id homepage{id}operations{operation targetType}}}`;
const $7ec1eb52421f9faa$export$f67032c82d01c852 = (0, $eSUdr.default)`query PageTreeWithSpaceKeyQuery($spaceKey:String!$statuses:[GraphQLPageStatus]$ptStatuses:[PTGraphQLPageStatus]$paginationLimit:Int$isSuperAdmin:Boolean!$isReplacePagesWithPTPageEnabled:Boolean!){space(key:$spaceKey){id homepageId pageTree(pageTree:$paginationLimit status:$ptStatuses enablePaging:true){id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}nearestAncestors{pageInfo{hasNextPage endCursor}nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}previousSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}followingSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}}}previousSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}followingSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}children{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}}operations{operation targetType}}ptpage(spaceKey:$spaceKey status:$ptStatuses)@include(if:$isReplacePagesWithPTPageEnabled){id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}followingSiblings{nodes{id title status createdDate(format:MILLIS){value}hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type subType links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}pageInfo{hasNextPage}}}rootLevelPages:pages(spaceKey:$spaceKey status:$statuses)@skip(if:$isReplacePagesWithPTPageEnabled){nodes{id title status hasChildren blank hasRestrictions@include(if:$isSuperAdmin)hasInheritedRestrictions@include(if:$isSuperAdmin)type links{webui}properties(keys:["emoji-title-published" "emoji-title-draft" "editor"]){nodes{id key value version{number}}}}}}`;
module.exports["PageTreeQuery"] = $7ec1eb52421f9faa$export$8d5511a885429a32;
module.exports["PageTreeWithSpaceKeyQuery"] = $7ec1eb52421f9faa$export$f67032c82d01c852;

});

parcelRegister("hXDOc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $42omo.useRef)(null);
    const preloadRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Do not proceed to the next stage if only JS preloading is enabled
        if (preloadOptions?.preloadingMode === "onlyJS") return;
        // Trigger next preloading stage either if everything is enabled or if critical data preloading
        // is enabled and the corresponding feature flag is enabled.
        const shouldPreload = preloadOptions?.preloadingMode === "everything" ? true : preloadOptions?.preloadingMode === "onlyJSAndCriticalData" && (0, $9wGTI.fg)('confluence_preload_critical_data');
        if (!shouldPreload) return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $42omo.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    return(// eslint-disable-next-line @atlassian/a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader",
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseEnter: onMouseEnter,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: onMouseLeave,
        onMouseDown: onMouseDown
    }, children));
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) {
        if ((0, $6mKj3.expVal)('platform_editor_hydratable_ui', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-vc": `hover-preloader-${props.name}`,
            "data-testid": "hover-preloader"
        }, props.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});

parcelRegister("aqBZ0", function(module, exports) {
const $1f65bcd6ebccf55c$export$41b2e06f27dfe96e = 'archived';
const $1f65bcd6ebccf55c$export$e2153f1ee0381860 = 'ARCHIVE_';
const $1f65bcd6ebccf55c$export$c8e98879124fb1f0 = 'UNARCHIVE_';
const $1f65bcd6ebccf55c$export$781b73bccf46ba2c = 255;
const $1f65bcd6ebccf55c$export$ab874a69c0b17d25 = 500;
var $1f65bcd6ebccf55c$export$ca079fdb822b790f = /*#__PURE__*/ function(ArchiveStatus) {
    ArchiveStatus["LOADING"] = "loading";
    ArchiveStatus["ERROR"] = "error";
    ArchiveStatus["SUCCESS"] = "success";
    return ArchiveStatus;
}({});
const $1f65bcd6ebccf55c$export$90622b83e51be397 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
const $1f65bcd6ebccf55c$export$a2742df05b19b873 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/#When-content-is-inheriting-restrictions-from-parent-content';
const $1f65bcd6ebccf55c$export$9de02bef22980fc = 'https://support.atlassian.com/confluence-cloud/docs/archive-pages/#Who-can-archive-an-item';
const $1f65bcd6ebccf55c$export$45c8fb669461b6d5 = 'https://support.atlassian.com/confluence-cloud/docs/restore-archived-pages-to-the-page-tree/#Who-can-restore-an-item';
module.exports["CONTENT_STATUS_ARCHIVED"] = $1f65bcd6ebccf55c$export$41b2e06f27dfe96e;
module.exports["ARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$e2153f1ee0381860;
module.exports["UNARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$c8e98879124fb1f0;
module.exports["ARCHIVE_PAGES_WITH_NOTE_CHARACTER_LIMIT"] = $1f65bcd6ebccf55c$export$781b73bccf46ba2c;
module.exports["BULK_ARCHIVE_PAGE_SELECTION_LIMIT"] = $1f65bcd6ebccf55c$export$ab874a69c0b17d25;
module.exports["ArchiveStatus"] = $1f65bcd6ebccf55c$export$ca079fdb822b790f;
module.exports["PAGE_INHERITED_RESTRICTIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$a2742df05b19b873;
module.exports["ARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$9de02bef22980fc;
module.exports["UNARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$45c8fb669461b6d5;

});

parcelRegister("7gpC4", function(module, exports) {
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $3654r = parcelRequire("3654r");


var $6MlG5 = parcelRequire("6MlG5");

var $9wgn8 = parcelRequire("9wgn8");

var $cVrnQ = parcelRequire("cVrnQ");

var $hcDON = parcelRequire("hcDON");

const $1f9fb6b4b3bc4020$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef78r4n _1h6r8r4n _smzgdfik _1dk7dfik _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $1f9fb6b4b3bc4020$var$Checkbox = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $42omo.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $42omo.useRef)(null);
    const mergedRefs = (0, $3654r.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $42omo.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $9wgn8.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $gMc0m.default)([
                    $1f9fb6b4b3bc4020$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6MlG5.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $l998X.jsxs)((0, $cVrnQ.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $l998X.jsx)((0, $hcDON.default), {})
                ]
            })
        ]
    });
}));
$1f9fb6b4b3bc4020$var$Checkbox.displayName = 'Checkbox';
var $1f9fb6b4b3bc4020$export$2e2bcd8739ae039 = $1f9fb6b4b3bc4020$var$Checkbox;
module.exports["default"] = $1f9fb6b4b3bc4020$export$2e2bcd8739ae039;

});

parcelRegister("6MlG5", function(module, exports) {
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $71feb0a29953fded$var$svgStyles = null;
function $71feb0a29953fded$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
     // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $71feb0a29953fded$var$CheckboxIcon = /*#__PURE__*/ (0, $42omo.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $42omo.useMemo)(()=>$71feb0a29953fded$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: 'var(--checkbox-background-color)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: 'var(--checkbox-tick-color)'
        },
        role: "presentation",
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }),
                icon
            ]
        })
    });
});
var $71feb0a29953fded$export$2e2bcd8739ae039 = $71feb0a29953fded$var$CheckboxIcon;
module.exports["default"] = $71feb0a29953fded$export$2e2bcd8739ae039;

});

parcelRegister("9wgn8", function(module, exports) {
$parcel$export(module.exports, "default", () => $edf27753e59bf881$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $edf27753e59bf881$var$baseStyles = null;
const $edf27753e59bf881$var$textLabelLayoutStyles = null;
const $edf27753e59bf881$var$disabledStyles = null;
const $edf27753e59bf881$var$labelStyles = null;
function $edf27753e59bf881$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("label", {
        className: (0, $gMc0m.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazi7uo _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1gmx _80om13gf",
            "_h5e31j9a _1nzsr01l _1eszjmqp _yp0j1q28 _ay2wby5v _d51ul4ek _phftrsbi _1g1f1l7x _l6wkjmqp _1dik1q28 _1sfg1bqt _fpdjby5v _1yjc1v1w _oaj1rsbi _1j3h1bqt _eawb5w2r _1rda5w2r _18q02sac _13hr1j28",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("cVrnQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0c2060f65a94bd0$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $f0c2060f65a94bd0$var$labelTextStyles = null;
function $f0c2060f65a94bd0$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("hcDON", function(module, exports) {
$parcel$export(module.exports, "default", () => $a14852587cdb2524$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $a14852587cdb2524$var$requiredIndicatorStyles = null;
function $a14852587cdb2524$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "aria-hidden": true,
        className: (0, $gMc0m.default)([
            "_syaz1tmw _bozgv77o"
        ]),
        children: "*"
    });
}

});

parcelRegister("a2xFu", function(module, exports) {

var $5KmYv = parcelRequire("5KmYv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/page/manifest.ts
var $74f4351b9cae92fc$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $5KmYv.ConfluencePageAriResourceOwner),
    resourceType: (0, $5KmYv.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $74f4351b9cae92fc$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $74f4351b9cae92fc$export$3f931dd15d96caff;

});

parcelRegister("5KmYv", function(module, exports) {
// src/confluence/page/types.ts
var $42f311f8b7b6730c$export$da53e4f7db4c6a71 = "confluence", $42f311f8b7b6730c$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $42f311f8b7b6730c$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $42f311f8b7b6730c$export$636fc622562a2c5b;

});

parcelRegister("882hS", function(module, exports) {
$parcel$export(module.exports, "pointerOutsideOfPreview", () => (parcelRequire("85Mv7")).pointerOutsideOfPreview);

var $85Mv7 = parcelRequire("85Mv7");


});

parcelRegister("85Mv7", function(module, exports) {

var $ic3Jg = parcelRequire("ic3Jg");


var $iFRCn = parcelRequire("iFRCn");


var $76xc7 = parcelRequire("76xc7");

function $30069a8958953d8b$export$427e20518819fabc(point) {
    return function getOffset({ container: container }) {
        /**
		 * **Approach: transparent borders.**
		 *
		 * The only reliable cross browser technique found to push a
		 * drag preview away from the cursor is to use transparent borders on the container.
		 *
		 * **🙅📱 Not pushing the preview away on touch devices**
		 *
		 * _On iOS_
		 *
		 * Safari will set the transparent border color to be black
		 *
		 * `iOS@18.4.1` on May 7th 2025:
		 * - If you set the background color on the `container` the border color will be that
		 * - Setting a transparent background color on the `container` still results in a
		 *   black border
		 * - The `<body>` text or background color does not change the black border color
		 *
		 * While dragging, the drag preview will shift under the center of the users pointer.
		 * So if you start at {x: 0, y: 0} (top left), almost immediately the preview will move
		 * to be under the middle of the users pointer.
		 *
		 * _On Android_
		 *
		 * Chrome will put the center of the drag preview under the users pointer immediately.
		 *
		 * Tested on `Chrome@137` on `Android 14` on June 20th 2025
		 *
		 * _What we do_
		 *
		 * We don't add the transparent border
		 *
		 * - Avoid the black color on iOS
		 * - It isn't needed on Android anyway as the preview will be under the center
		 *   of the users pointer
		 *
		 * We put the center of the drag preview under the users pointer
		 *
		 * - Avoids the drag preview quickly moving from a top corner to be centered under
		 *   the users pointer on iOS
		 * - It will be under the center on Android no matter what we do
		 *
		 * We previously had a isTouchDevice() check, but it felt safer for now
		 * to have a more targeted check, as these are the devices that have been
		 * tested on.
		 */ if ((0, $iFRCn.isSafariOnIOS)() || (0, $ic3Jg.isAndroid)()) return (0, $76xc7.centerUnderPointer)({
            container: container
        });
        Object.assign(container.style, {
            borderInlineStart: `${point.x} solid transparent`,
            borderTop: `${point.y} solid transparent`
        });
        // Unfortunate that we need to use `getComputedStyle`,
        // but it's only a single call when the drag is starting.
        const computed = window.getComputedStyle(container);
        if (computed.direction === 'rtl') {
            // The DOMRect will include the new border we added
            const box = container.getBoundingClientRect();
            // Use the top right corner (including the new border) as the offset.
            // The border will push the preview away from the pointer.
            return {
                x: box.width,
                y: 0
            };
        }
        // Use the top left corner as the offset. The border will
        // push the preview away from the pointer.
        return {
            x: 0,
            y: 0
        };
    };
}
module.exports["pointerOutsideOfPreview"] = $30069a8958953d8b$export$427e20518819fabc;

});

parcelRegister("iFRCn", function(module, exports) {

var $aYpzB = parcelRequire("aYpzB");


var $e880Z = parcelRequire("e880Z");

const $3720fb1a551ae595$export$52fc40c68fea4952 = (0, $aYpzB.once)(function isSafariOnIOS() {
    return (0, $e880Z.isSafari)() && 'ontouchend' in document;
});
module.exports["isSafariOnIOS"] = $3720fb1a551ae595$export$52fc40c68fea4952;

});

parcelRegister("76xc7", function(module, exports) {
const $54acc06d1c628398$export$81d8e72a15eef435 = function centerUnderPointer({ container: container }) {
    const rect = container.getBoundingClientRect();
    return {
        x: rect.width / 2,
        y: rect.height / 2
    };
};
module.exports["centerUnderPointer"] = $54acc06d1c628398$export$81d8e72a15eef435;

});

parcelRegister("8Yfbq", function(module, exports) {

var $jSnXV = parcelRequire("jSnXV");


var $lc9ud = parcelRequire("lc9ud");

/** Error message constants. */ var $687fb4659a5afde2$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $687fb4659a5afde2$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($687fb4659a5afde2$var$FUNC_ERROR_TEXT);
    if ($lc9ud(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $jSnXV(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = $687fb4659a5afde2$var$throttle;

});

parcelRegister("da6ky", function(module, exports) {

var $ghltV = parcelRequire("ghltV");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $99511ea06e3a3663$var$uniq(array) {
    return array && array.length ? $ghltV(array) : [];
}
module.exports = $99511ea06e3a3663$var$uniq;

});

parcelRegister("6wbAc", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $852cc06e57df817b$export$83b038038df2eb9 = (0, $eSUdr.default)`query SpaceRestrictionCheckQuery($spaceKey:String!){space(key:$spaceKey){id settings{routeOverrideEnabled}}}`;
module.exports["SpaceRestrictionCheckQuery"] = $852cc06e57df817b$export$83b038038df2eb9;

});

parcelRegister("fG32j", function(module, exports) {

var $j1Ss3 = parcelRequire("j1Ss3");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $6jrkJ = parcelRequire("6jrkJ");


var $6mKj3 = parcelRequire("6mKj3");


var $3joiD = parcelRequire("3joiD");


var $6wbAc = parcelRequire("6wbAc");

function $06e8bea7aad8a7b8$export$f1b4255eb8ae314e({ asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey }) {
    const superAdminClaim = (0, $6jrkJ.getSuperAdminClaim)();
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let data, error, loading;
    if ((0, $6mKj3.expVal)('confluence_restrictions_fix', 'isEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const result = (0, $j1Ss3.useQuery)(...(0, $3joiD.getQueryParamsAndSetFetchPolicyForNetworkOnlyQuery)({
            query: (0, $6wbAc.SpaceRestrictionCheckQuery),
            context: asSuperAdmin == undefined ? undefined : {
                asSuperAdmin: asSuperAdmin
            },
            errorPolicy: 'all',
            variables: {
                // XXX Though SpaceRestrictionCheckProps defines spaceKey as required,
                // SpaceBaseComponent is not written in TypeScript and it may provide
                // undefined as it is reading spaceKey from redux. While it would result
                // in a better separation of concerns to have a fix in SpaceBaseComponent,
                // such a fix would be riskier.
                spaceKey: spaceKey || stateSpaceKey
            }
        }));
        data = result.data;
        error = result.error;
        loading = result.loading;
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const result = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations
        (0, $6wbAc.SpaceRestrictionCheckQuery), {
            context: asSuperAdmin == undefined ? undefined : {
                asSuperAdmin: asSuperAdmin
            },
            fetchPolicy: superAdminClaim ? 'no-cache' : 'network-only',
            errorPolicy: 'all',
            variables: {
                // XXX Though SpaceRestrictionCheckProps defines spaceKey as required,
                // SpaceBaseComponent is not written in TypeScript and it may provide
                // undefined as it is reading spaceKey from redux. While it would result
                // in a better separation of concerns to have a fix in SpaceBaseComponent,
                // such a fix would be riskier.
                spaceKey: spaceKey || stateSpaceKey
            }
        });
        data = result.data;
        error = result.error;
        loading = result.loading;
    }
    let isErrorHandled;
    let isSpaceNotFound;
    let isSpaceRestricted;
    if (error) {
        isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
        isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
        if (isSpaceNotFound || isSpaceRestricted) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            isErrorHandled = true;
        }
    } else if (data) {
        isSpaceNotFound = false;
        isSpaceRestricted = false;
    }
    if ((0, $6mKj3.expVal)('confluence_restrictions_fix', 'isEnabled', false)) {
        if (loading) return null;
        return children({
            error: error,
            isSpaceNotFound: isSpaceNotFound,
            isSpaceRestricted: isSpaceRestricted
        });
    } else return children({
        error: isErrorHandled ? undefined : error,
        isSpaceNotFound: isSpaceNotFound,
        isSpaceRestricted: isSpaceRestricted,
        loading: loading
    });
}
function $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ({ statusCode: statusCode })=>statusCode === 404 || statusCode === 400);
}
function $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ()=>(0, $1uFM6.isUnauthorizedError)(error));
}
function $06e8bea7aad8a7b8$var$isSpaceError({ graphQLErrors: graphQLErrors }, extensionsPredicate) {
    if (graphQLErrors && graphQLErrors.length > 0) for (const { extensions: extensions, path: path } of graphQLErrors){
        if (Array.isArray(path) && path.indexOf('space') !== -1 && extensions && extensionsPredicate(extensions)) return true;
    }
    return false;
}
module.exports["SpaceRestrictionCheck"] = $06e8bea7aad8a7b8$export$f1b4255eb8ae314e;
module.exports["isSpaceNotFoundError"] = $06e8bea7aad8a7b8$export$498e7daa29ea2c61;
module.exports["isSpaceRestrictedError"] = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef;

});

parcelRegister("7aRa9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("cLo2u", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

const $91bacb73ef37142f$export$12ed3d1363567203 = (0, $3u0dr.isReactCompilerActiveV1)() ? function useSpaceKey(spaceKey) {
    const $ = (0, $frIzR.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
} : function useSpaceKey(spaceKey) {
    // Space-level data is used to retrieve information about a space's external collaborators
    // in multiple places across the package. Attempt to get spaceKey from a range of sources.
    // If we are in a view-page context, spaceKey data may be available from PageState.
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    // Otherwise, RoutesContext may contain the information we need
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    // Now that our context hooks have executed, we can return if we have a match.
    // Return statements are separated out for optimum readability.
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    // Legacy server-rendered UI pages do not have the "match" object in RoutesContext, but
    // they can contain space information in the <meta> data tag.
    const documentMetaSpaceKey = typeof document !== 'undefined' ? document.querySelector('meta#confluence-space-key')?.content : null;
    return documentMetaSpaceKey ?? null;
};
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("2BAFx", function(module, exports) {
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();
module.exports["dialogKeyState"] = $d32907502a426d2e$export$2e170616461fb3b6;

});

parcelRegister("kRW4Y", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $2BAFx = parcelRequire("2BAFx");

class $c329db8a0d5b9472$export$11ff2eb6414212c6 extends (0, $T1bCI.Container) {
    onChildClose(key, ...args) {
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        this.setState((state)=>({
                stack: state.stack.map((frame)=>frame === childFrame ? {
                        ...frame,
                        alive: false
                    } : frame)
            }));
    }
    onChildCloseComplete(key, ...args) {
        // A child dialog called its onCloseComplete prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        this.setState((state)=>({
                stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
            }));
    }
    constructor(stack = []){
        super();
        /*
        Arguably, nextKey belongs in state (as per 'flags' package). But then there's
        an unenviable choice of, in showDialog, putting the React.createElement in the
        setState callback, or giving setState an object instead of a callback and
        risk having two dialogs opened with the same key in the (unlikely) scenario
        that they're both opened in the same tick.
      */ this.showModal = (componentClass, originalProps, children)=>{
            this.showDialog(componentClass, originalProps, children);
        };
        /**
     * @deprecated use `.showModal()` instead (see "next/packages/dialogs/README.md" for migration instructions)
     */ this.showDialog = (componentClass, originalProps, children)=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: (...args)=>this.onChildClose(key, ...args),
                onCloseComplete: (...args)=>this.onChildCloseComplete(key, ...args)
            }, children);
            this.setState((state)=>({
                    stack: [
                        ...state.stack,
                        {
                            key: key,
                            component: component,
                            alive: true,
                            originalProps: {
                                onClose: 'onClose' in props ? props.onClose : undefined,
                                onCloseComplete: 'onCloseComplete' in props ? props.onCloseComplete : undefined
                            }
                        }
                    ]
                }));
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return ()=>{
                this.onChildClose(key);
            };
        };
        this.state = {
            stack: stack
        };
        // If you're pre-supplying a stack, make nextKey bigger than any of its keys
        if (stack.length) {
            const maxKey = Math.max(...stack.map((frame)=>frame.key));
            (0, $2BAFx.dialogKeyState).nextKey = maxKey + 1;
        }
    }
}
module.exports["DialogsStateContainer"] = $c329db8a0d5b9472$export$11ff2eb6414212c6;

});

parcelRegister("hHyea", function(module, exports) {

var $jcOUW = parcelRequire("jcOUW");


var $7LQYo = parcelRequire("7LQYo");


var $lkNSx = parcelRequire("lkNSx");


var $5ukOg = parcelRequire("5ukOg");


var $dFnBO = parcelRequire("dFnBO");


var $bcPN2 = parcelRequire("bcPN2");

/** Used as the size to enable large array optimizations. */ var $ce3100b697e139b9$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $ce3100b697e139b9$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $7LQYo, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $5ukOg(values, $dFnBO(iteratee));
    if (comparator) {
        includes = $lkNSx;
        isCommon = false;
    } else if (values.length >= $ce3100b697e139b9$var$LARGE_ARRAY_SIZE) {
        includes = $bcPN2;
        isCommon = false;
        values = new $jcOUW(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = $ce3100b697e139b9$var$baseDifference;

});

parcelRegister("jJDs8", function(module, exports) {

var $fYKLM = parcelRequire("fYKLM");

// using a symbol so we can guarantee a key with a unique value
const $b7b680fbf5b4f84f$var$uniqueKey = Symbol('tree-item-instruction');
function $b7b680fbf5b4f84f$var$getCenter(rect) {
    return {
        x: (rect.right + rect.left) / 2,
        y: (rect.bottom + rect.top) / 2
    };
}
function $b7b680fbf5b4f84f$var$standardHitbox({ client: client, borderBox: borderBox }) {
    const quarterOfHeight = borderBox.height / 4;
    // In the top 1/4: reorder-above
    // On the line = in the top 1/4 to give this zone a bit more space
    if (client.y <= borderBox.top + quarterOfHeight) return 'reorder-above';
    // In the bottom 1/4: reorder-below
    // On the line = in the bottom 1/4 to give this zone a bit more space
    if (client.y >= borderBox.bottom - quarterOfHeight) return 'reorder-below';
    return 'make-child';
}
function $b7b680fbf5b4f84f$var$getInstruction({ element: element, input: input, currentLevel: currentLevel, indentPerLevel: indentPerLevel, mode: mode }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const borderBox = element.getBoundingClientRect();
    if (mode === 'standard') {
        const type = $b7b680fbf5b4f84f$var$standardHitbox({
            borderBox: borderBox,
            client: client
        });
        return {
            type: type,
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    const center = $b7b680fbf5b4f84f$var$getCenter(borderBox);
    if (mode === 'expanded') {
        // leveraging "standard" hitbox to ensure that the 'reorder-above' hit zone is
        // exactly the same for "standard" and "expanded" items
        const type = $b7b680fbf5b4f84f$var$standardHitbox({
            borderBox: borderBox,
            client: client
        });
        return {
            // Use the "standard" hitbox for "reorder above",
            // The rest of the item is "make-child"
            type: type === 'reorder-above' ? type : 'make-child',
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    // `mode` is "last-in-group"
    const visibleInset = indentPerLevel * currentLevel;
    // Before the left edge of the visible item
    if (client.x < borderBox.left + visibleInset) {
        // Above the center: `reorder-above`
        if (client.y < center.y) return {
            type: 'reorder-above',
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
        // On or below the center: `reparent`
        // On the center = `reparent` as we are giving a slightly bigger hitbox to this
        // action as it is the only place a user can do it
        const rawLevel = (client.x - borderBox.left) / indentPerLevel;
        // We can get sub pixel negative numbers as getBoundingClientRect gives sub-pixel accuracy,
        // where as clientX is rounded to the nearest pixel.
        // Using Math.max() ensures we can never get a negative level
        const desiredLevel = Math.max(Math.floor(rawLevel), 0);
        return {
            type: 'reparent',
            desiredLevel: desiredLevel,
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    // On the visible item
    return {
        type: $b7b680fbf5b4f84f$var$standardHitbox({
            borderBox: borderBox,
            client: client
        }),
        indentPerLevel: indentPerLevel,
        currentLevel: currentLevel
    };
}
function $b7b680fbf5b4f84f$var$areInstructionsEqual(a, b) {
    // Shortcut
    if (a.type !== b.type) return false;
    if (a.type === 'instruction-blocked' && b.type === 'instruction-blocked') return $b7b680fbf5b4f84f$var$areInstructionsEqual(a.desired, b.desired);
    return (0, $fYKLM.isShallowEqual)(a, b);
}
// Note: not using `memoize-one` as all we need is a cached value.
// We do not need to avoid executing an expensive function.
const $b7b680fbf5b4f84f$var$memoizeInstruction = (0, $fYKLM.stable)($b7b680fbf5b4f84f$var$areInstructionsEqual);
function $b7b680fbf5b4f84f$var$applyInstructionBlock({ desired: desired, block: block }) {
    if (block?.includes(desired.type) && desired.type !== 'instruction-blocked') {
        const blocked = {
            type: 'instruction-blocked',
            desired: desired
        };
        return blocked;
    }
    return desired;
}
function $b7b680fbf5b4f84f$export$267ad49d812c2c7f(userData, { block: block, ...rest }) {
    const desired = $b7b680fbf5b4f84f$var$getInstruction(rest);
    const withBlock = $b7b680fbf5b4f84f$var$applyInstructionBlock({
        desired: desired,
        block: block
    });
    const memoized = $b7b680fbf5b4f84f$var$memoizeInstruction(withBlock);
    return {
        ...userData,
        [$b7b680fbf5b4f84f$var$uniqueKey]: memoized
    };
}
function $b7b680fbf5b4f84f$export$c8ffecbe249dc8f8(userData) {
    return userData[$b7b680fbf5b4f84f$var$uniqueKey] ?? null;
}
module.exports["attachInstruction"] = $b7b680fbf5b4f84f$export$267ad49d812c2c7f;
module.exports["extractInstruction"] = $b7b680fbf5b4f84f$export$c8ffecbe249dc8f8;

});

parcelRegister("fYKLM", function(module, exports) {
function $440eac8f72738c8c$export$2225b4c39d37f8b3(a, b) {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    return aKeys.every((key)=>Object.is(a[key], b[key]));
}
function $440eac8f72738c8c$export$3f55479a3469259f(isEqual = $440eac8f72738c8c$export$2225b4c39d37f8b3) {
    let cache = null;
    return (value)=>{
        if (cache && isEqual(cache.value, value)) return cache.value;
        cache = {
            value: value
        };
        return cache.value;
    };
}
module.exports["isShallowEqual"] = $440eac8f72738c8c$export$2225b4c39d37f8b3;
module.exports["stable"] = $440eac8f72738c8c$export$3f55479a3469259f;

});

parcelRegister("ft7TS", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $aTio4 = parcelRequire("aTio4");


var $2n8po = parcelRequire("2n8po");

function $51f217e12c7a77e2$var$getElement({ instruction: instruction, isBlocked: isBlocked }) {
    const indent = `${instruction.currentLevel * instruction.indentPerLevel}px`;
    const appearance = isBlocked ? 'warning' : 'default';
    if (instruction.type === 'reorder-above') return /*#__PURE__*/ (0, $l998X.jsx)((0, $2n8po.DropIndicator), {
        edge: "top",
        appearance: appearance,
        indent: indent
    });
    if (instruction.type === 'reorder-below') return /*#__PURE__*/ (0, $l998X.jsx)((0, $2n8po.DropIndicator), {
        edge: "bottom",
        appearance: appearance,
        indent: indent
    });
    if (instruction.type === 'make-child') return /*#__PURE__*/ (0, $l998X.jsx)((0, $aTio4.DropIndicator), {
        appearance: appearance,
        indent: indent
    });
    if (instruction.type === 'reparent') {
        const reparentIndent = `${instruction.desiredLevel * instruction.indentPerLevel}px`;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $2n8po.DropIndicator), {
            edge: "bottom",
            appearance: appearance,
            indent: reparentIndent
        });
    }
    return null;
}
function $51f217e12c7a77e2$export$62ed72bc21f6b8a6({ instruction: instruction }) {
    if (instruction.type === 'instruction-blocked') return $51f217e12c7a77e2$var$getElement({
        instruction: instruction.desired,
        isBlocked: true
    });
    return $51f217e12c7a77e2$var$getElement({
        instruction: instruction,
        isBlocked: false
    });
}
module.exports["DropIndicator"] = $51f217e12c7a77e2$export$62ed72bc21f6b8a6;

});

parcelRegister("aTio4", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8Mgg9 = parcelRequire("8Mgg9");


var $9JSVA = parcelRequire("9JSVA");

function $f32cc2f93c269bf0$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', indent: indent }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8Mgg9.Border), {
        strokeColor: (0, $9JSVA.presetStrokeColors)[appearance],
        indent: indent
    });
}
var // For React.lazy
$f32cc2f93c269bf0$export$2e2bcd8739ae039 = $f32cc2f93c269bf0$export$62ed72bc21f6b8a6;
module.exports["DropIndicator"] = $f32cc2f93c269bf0$export$62ed72bc21f6b8a6;

});

parcelRegister("8Mgg9", function(module, exports) {
/* border.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9JSVA = parcelRequire("9JSVA");

const $e9c9b85493bf64c6$var$styles = null;
function $e9c9b85493bf64c6$export$d8e9c9d63e86d41e({ strokeColor: strokeColor = (0, $9JSVA.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $9JSVA.presetStrokeWidth), borderRadius: borderRadius = '3px', indent: // TODO: update to radius.small (4px) token
indent = '0px' }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            '--border-radius': borderRadius,
            '--indent': indent
        },
        className: (0, $gMc0m.default)([
            "_19it1ebc _2rko1koq _kqswstnw _152tidpf _u7coidpf _rjxpidpf _1e02armj _lcxvglyw"
        ])
    });
} // For React.lazy
var $e9c9b85493bf64c6$export$2e2bcd8739ae039 = $e9c9b85493bf64c6$export$d8e9c9d63e86d41e;
module.exports["Border"] = $e9c9b85493bf64c6$export$d8e9c9d63e86d41e;

});

parcelRegister("6p02T", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $iXCQx = parcelRequire("iXCQx");

const $3cbad44d75de57c9$var$SPECIAL_CHARS_REGEX = /^[!#$%^&*() ,.<>?\/\[\]_\-+=`~\|:;{}\\]+/;
const $3cbad44d75de57c9$export$16c2ab98757b54d6 = (excerpt)=>{
    excerpt = excerpt.trim();
    if (!excerpt) // eslint-disable-next-line @atlaskit/design-system/use-primitives-text -- can't use primitives here
    return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            key: "empty"
        })
    ];
    const beginsWithHighlight = excerpt.slice(0, 8) === '@@@hl@@@';
    const beginsWithUrl = excerpt.slice(0, 4) === 'http' || beginsWithHighlight && excerpt.slice(8, 12) === 'http';
    // Strip leading special characters unless the excerpt begins with a highlight
    if (!beginsWithHighlight) excerpt = excerpt.replace($3cbad44d75de57c9$var$SPECIAL_CHARS_REGEX, '');
    // Add ellipses prefix if beginning of excerpt isn't a URL and begins with a lowercase letter (unbolded or bolded)
    if (!beginsWithUrl && (!beginsWithHighlight && excerpt[0] && excerpt[0] === excerpt[0].toLowerCase() || beginsWithHighlight && excerpt[8] && excerpt[8] === excerpt[8].toLowerCase())) excerpt = '...'.concat(excerpt);
    // Add elipses suffix if excerpt doesn't end with ending punctuation
    if (!excerpt.slice(-1).match(/[.!?]/)) excerpt = excerpt.concat('...');
    // Replace line breaks with seperators
    excerpt = excerpt.replace(/\n+/g, " \xb7 ");
    return $3cbad44d75de57c9$export$b847312d69858d61(excerpt);
};
const $3cbad44d75de57c9$export$b847312d69858d61 = (excerpt)=>{
    const res = [];
    let pre, textMatch;
    let i = 0;
    while(excerpt){
        // @ts-expect-error - TS1501 Typescript 5.9.2 upgrade
        const match = excerpt.match(RegExp("(.*?)@@@hl@@@(.*?)@@@endhl@@@(.*)", "s"));
        if (!match) {
            res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                key: excerpt
            }, excerpt));
            break;
        }
        [, pre, textMatch, excerpt] = match;
        if (pre) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            key: `pre-${i}`
        }, pre));
        if (textMatch) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            as: "strong",
            key: `textMatch-${i}`
        }, textMatch));
        i++;
    }
    return res;
};
const $3cbad44d75de57c9$export$7512fe8206a7f75b = (text)=>text && text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
module.exports["processExcerpt"] = $3cbad44d75de57c9$export$16c2ab98757b54d6;
module.exports["enrichExcerpt"] = $3cbad44d75de57c9$export$b847312d69858d61;
module.exports["cleanExcerpt"] = $3cbad44d75de57c9$export$7512fe8206a7f75b;

});

parcelRegister("dYA5q", function(module, exports) {
/* LivePagePreloader.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $9wGTI = parcelRequire("9wGTI");


var $7W8i8 = parcelRequire("7W8i8");


var $39rFu = parcelRequire("39rFu");

const $15ad27b3337f3f82$var$logger = (0, $7W8i8.getLogger)('LivePagePreloader');
const $15ad27b3337f3f82$export$6eca3633b04cd128 = ({ isLivePage: isLivePage, children: children })=>{
    const { livePageComponentsPreloader: livePageComponentsPreloader } = (0, $39rFu.useEditPageLoadingActions)();
    const [isPreloading, setIsPreloading] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!isPreloading || !isLivePage) return;
        const preloadComponents = ()=>{
            livePageComponentsPreloader?.().catch((error)=>{
                $15ad27b3337f3f82$var$logger.error`Preloading live page components failed ${error}`;
            }).finally(()=>{
                setIsPreloading(false);
            });
        };
        preloadComponents();
    }, [
        isPreloading,
        isLivePage,
        livePageComponentsPreloader
    ]);
    const triggerPreload = (0, $42omo.useCallback)(()=>{
        if (isLivePage && !isPreloading) setIsPreloading(true);
    }, [
        isLivePage,
        isPreloading
    ]);
    if (!isLivePage || !(0, $9wGTI.fg)('confluence_perf_preload_livepage_assets')) return children;
    return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        // presentation role here to tell screen readers that this is not interactive
        role: "presentation",
        onMouseEnter: triggerPreload,
        onFocus: triggerPreload,
        xcss: (0, $1Whri.cx)($15ad27b3337f3f82$var$styles.box)
    }, children);
};
const $15ad27b3337f3f82$var$styles = {
    box: "_4t3i1osq _1bsb1osq"
};
module.exports["LivePagePreloader"] = $15ad27b3337f3f82$export$6eca3633b04cd128;

});

parcelRegister("aDQuI", function(module, exports) {

var $8jC8i = parcelRequire("8jC8i");


var $hWvFC = parcelRequire("hWvFC");


var $9JSQw = parcelRequire("9JSQw");


var $ghltV = parcelRequire("ghltV");


var $bVtKl = parcelRequire("bVtKl");


var $apAFY = parcelRequire("apAFY");

/**
 * This method is like `_.union` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which uniqueness is computed. Result values are chosen from the first
 * array in which the value occurs. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.unionBy([2.1], [1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ var $7bf644369363a294$var$unionBy = $9JSQw(function(arrays) {
    var iteratee = $apAFY(arrays);
    if ($bVtKl(iteratee)) iteratee = undefined;
    return $ghltV($8jC8i(arrays, 1, $bVtKl, true), $hWvFC(iteratee, 2));
});
module.exports = $7bf644369363a294$var$unionBy;

});

parcelRegister("iSXh4", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $7Sm4c = parcelRequire("7Sm4c");


var $bQm3c = parcelRequire("bQm3c");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $5ZqQS = parcelRequire("5ZqQS");

const $270f2eb7bad14df2$var$createAriId = (cloudId, pageId)=>`ari:cloud:confluence:${cloudId}:page/${pageId}`;
const $270f2eb7bad14df2$var$AutomatedMeetingNotesPagePropertiesQuery = (0, $eSUdr.default)`query useAutomatedMeetingNotesPagePropertiesQuery($pageAri:ID!){page(id:$pageAri){properties(keys:["isAutomatedMeetingNotes" "meetingRecurrenceAri"]){nodes{key value}}subType}}`;
const $270f2eb7bad14df2$var$IsAutomatedMeetingNotesPropertyKey = 'isAutomatedMeetingNotes';
const $270f2eb7bad14df2$var$MeetingRecurrenceAriPropertyKey = 'meetingRecurrenceAri';
const $270f2eb7bad14df2$export$d2c3b4dbe2618d37 = (pageId)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($270f2eb7bad14df2$var$AutomatedMeetingNotesPagePropertiesQuery, {
        variables: {
            pageAri: $270f2eb7bad14df2$var$createAriId(cloudId, pageId)
        }
    });
    (0, $42omo.useEffect)(()=>{
        if (error) {
            if (!(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).INTEGRATIONS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error
    ]);
    return {
        isLoading: loading,
        ...$270f2eb7bad14df2$export$1607cf22d9dbad(data)
    };
};
const $270f2eb7bad14df2$export$1607cf22d9dbad = (data)=>{
    const pageProperties = data?.page?.properties?.nodes;
    const amnProperty = pageProperties?.find((property)=>property?.key === $270f2eb7bad14df2$var$IsAutomatedMeetingNotesPropertyKey);
    const recurrenceProperty = pageProperties?.find((property)=>property?.key === $270f2eb7bad14df2$var$MeetingRecurrenceAriPropertyKey);
    const isAMN = amnProperty?.value === 'true';
    const isRecurringParent = recurrenceProperty != undefined;
    const isLiveAMNPage = data?.page?.subType?.toLowerCase() === 'live' && isAMN;
    return {
        isAMN: isAMN,
        isRecurringParent: isRecurringParent,
        isLiveAMNPage: isLiveAMNPage
    };
};
module.exports["useAutomatedMeetingNotesPageProperties"] = $270f2eb7bad14df2$export$d2c3b4dbe2618d37;
module.exports["extractAmnPageProperties"] = $270f2eb7bad14df2$export$1607cf22d9dbad;

});

parcelRegister("3Xs1I", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $1SNEF = parcelRequire("1SNEF");

const $cf20926a3ed5ce71$export$b107cc869756fe73 = (0, $3u0dr.isReactCompilerActiveV1)() ? (reloaderProps)=>{
    (0, $1SNEF.useQuickReloadSubscriber)(reloaderProps);
    return null;
} : (reloaderProps)=>{
    (0, $1SNEF.useQuickReloadSubscriber)(reloaderProps);
    return null;
};
module.exports["QuickReloadSubscriber"] = $cf20926a3ed5ce71$export$b107cc869756fe73;

});

parcelRegister("1SNEF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $c0urc = parcelRequire("c0urc");

const $511608ca1b2c45b1$export$2f94e407b6c7d69d = (reloader)=>{
    const { contentId: contentId, registerReloader: registerReloader, unregisterReloader: unregisterReloader } = (0, $42omo.useContext)((0, $c0urc.QuickReloadContext));
    (0, $42omo.useEffect)(()=>{
        registerReloader(reloader);
        return ()=>{
            unregisterReloader(reloader);
        };
    // NOTE: these are only dependencies of this effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        reloader.name
    ]);
};
module.exports["useQuickReloadSubscriber"] = $511608ca1b2c45b1$export$2f94e407b6c7d69d;

});

parcelRegister("kSPGK", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

class $5d6af3820d303892$var$OptimisticTitleChangeEventBus {
    emit(contentId, title) {
        if (this.listeners[contentId]) this.listeners[contentId].forEach((fn)=>{
            fn(title);
        });
    }
    subscribe(contentId, fn) {
        if (!this.listeners[contentId]) this.listeners[contentId] = [];
        this.listeners[contentId].push(fn);
    }
    unsubcribe(contentId, fn) {
        if (this.listeners[contentId]) {
            const index = this.listeners[contentId].findIndex((item)=>item[0] === fn);
            if (index !== -1) this.listeners[contentId].splice(index, 1);
        }
    }
    constructor(){
        this.listeners = void 0;
        this.listeners = {};
    }
}
const $5d6af3820d303892$var$optimisticTitleChangeEventBus = new $5d6af3820d303892$var$OptimisticTitleChangeEventBus();
const $5d6af3820d303892$export$255638cdf0226b65 = (0, $3u0dr.isReactCompilerActiveV1)() ? (contentId, initialTitle, onOptimisticUpdate)=>{
    const $ = (0, $frIzR.c)(16);
    const [optimisticTitle, setOptimisticTitle] = (0, $42omo.useState)(initialTitle);
    let t0;
    if ($[0] !== contentId || $[1] !== optimisticTitle) {
        t0 = (value)=>{
            if (value !== optimisticTitle) $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.emit(contentId, value);
        };
        $[0] = contentId;
        $[1] = optimisticTitle;
        $[2] = t0;
    } else t0 = $[2];
    const publishOptimisticTitle = t0;
    let t1;
    if ($[3] !== contentId || $[4] !== onOptimisticUpdate) {
        t1 = (title)=>{
            setOptimisticTitle(title);
            onOptimisticUpdate && onOptimisticUpdate(contentId, title);
        };
        $[3] = contentId;
        $[4] = onOptimisticUpdate;
        $[5] = t1;
    } else t1 = $[5];
    const handleTitleChanged = t1;
    let t2;
    let t3;
    if ($[6] !== contentId || $[7] !== handleTitleChanged) {
        t2 = ()=>{
            $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.subscribe(contentId, handleTitleChanged);
            return ()=>{
                $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.unsubcribe(contentId, handleTitleChanged);
            };
        };
        t3 = [
            contentId,
            handleTitleChanged
        ];
        $[6] = contentId;
        $[7] = handleTitleChanged;
        $[8] = t2;
        $[9] = t3;
    } else {
        t2 = $[8];
        t3 = $[9];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[10] !== initialTitle) {
        t4 = ()=>{
            setOptimisticTitle(initialTitle);
        };
        t5 = [
            initialTitle
        ];
        $[10] = initialTitle;
        $[11] = t4;
        $[12] = t5;
    } else {
        t4 = $[11];
        t5 = $[12];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[13] !== optimisticTitle || $[14] !== publishOptimisticTitle) {
        t6 = {
            optimisticTitle: optimisticTitle,
            setOptimisticTitle: publishOptimisticTitle
        };
        $[13] = optimisticTitle;
        $[14] = publishOptimisticTitle;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : (contentId, initialTitle, onOptimisticUpdate)=>{
    const [optimisticTitle, setOptimisticTitle] = (0, $42omo.useState)(initialTitle);
    const publishOptimisticTitle = (0, $42omo.useCallback)((value)=>{
        if (value !== optimisticTitle) $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.emit(contentId, value);
    }, [
        contentId,
        optimisticTitle
    ]);
    const handleTitleChanged = (0, $42omo.useCallback)((title)=>{
        setOptimisticTitle(title);
        onOptimisticUpdate && onOptimisticUpdate(contentId, title);
    }, [
        contentId,
        setOptimisticTitle,
        onOptimisticUpdate
    ]);
    (0, $42omo.useEffect)(()=>{
        $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.subscribe(contentId, handleTitleChanged);
        return ()=>{
            $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.unsubcribe(contentId, handleTitleChanged);
        };
    }, [
        contentId,
        handleTitleChanged
    ]);
    // If initialTitle changes, update optimistic title to match new initialTitle.
    // Why? This fixes scenarios where the BE title of the page changes without the title changing on the FE, e.g. when a draft with no title is converted to a live page with a title generated by the BE.
    //      Without this useEffect, the title will undesirably stay as the original initialTitle of "Untitled" instead of using the new title from the BE.
    (0, $42omo.useEffect)(()=>{
        setOptimisticTitle(initialTitle);
    }, [
        initialTitle
    ]);
    return {
        optimisticTitle: optimisticTitle,
        setOptimisticTitle: publishOptimisticTitle
    };
};
module.exports["useOptimisticTitleChange"] = $5d6af3820d303892$export$255638cdf0226b65;

});

parcelRegister("4K4h4", function(module, exports) {
$parcel$export(module.exports, "ContentTreeIcon", () => (parcelRequire("iU0gR")).ContentTreeIcon);

var $jmjWc = parcelRequire("jmjWc");


var $iU0gR = parcelRequire("iU0gR");


const $61f85e63c6992485$export$e511f243d20dd25e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "g-l5_",
    name: "ContentTreeIconLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("iU0gR")))).ContentTreeIcon
});
module.exports["ContentTreeIconLoader"] = $61f85e63c6992485$export$e511f243d20dd25e;

});

parcelRegister("iU0gR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8jHAi = parcelRequire("8jHAi");


var $ZDq1z = parcelRequire("ZDq1z");


var $6B0jU = parcelRequire("6B0jU");


var $eG1e2 = parcelRequire("eG1e2");


var $5tmwS = parcelRequire("5tmwS");


var $e0ycV = parcelRequire("e0ycV");

const $3b6036244b1fd25e$export$160f5c89496b5ea9 = ({ label: label, color: color, spacing: spacing, type: type, isExpanded: isExpanded = false })=>{
    const contentTreeIconTypes = {
        page: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        whiteboard: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        database: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        folder: isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($eG1e2))) : (0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))),
        liveDoc: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV)))
    };
    const icon = contentTreeIconTypes[type];
    const testId = `content-tree-icon${spacing !== 'none' ? `-${spacing}` : ''}-${type}${type === 'folder' && isExpanded ? '-open' : ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(icon, {
        spacing: spacing,
        label: label,
        color: color,
        testId: testId
    });
};
module.exports["ContentTreeIcon"] = $3b6036244b1fd25e$export$160f5c89496b5ea9;

});

parcelRegister("6bZDi", function(module, exports) {
const $a8768b1a0c8c67c8$export$ee7a362b3ed8b036 = [
    'page',
    'whiteboard',
    'database',
    'folder',
    'liveDoc'
];
const $a8768b1a0c8c67c8$export$a73714094b2817b7 = (obj)=>typeof obj === 'string' && $a8768b1a0c8c67c8$export$ee7a362b3ed8b036.includes(obj);
const $a8768b1a0c8c67c8$export$204659eac14d740b = (obj)=>$a8768b1a0c8c67c8$export$a73714094b2817b7(obj) ? obj : undefined;
const $a8768b1a0c8c67c8$export$c7c48cc42c0546b7 = (contentType, isNav4Enabled)=>{
    const contentTreeType = $a8768b1a0c8c67c8$export$204659eac14d740b(contentType);
    if (!isNav4Enabled && contentTreeType === 'page') return false;
    return !!contentTreeType && $a8768b1a0c8c67c8$export$ee7a362b3ed8b036.includes(contentTreeType);
};
module.exports["isContentTreeType"] = $a8768b1a0c8c67c8$export$a73714094b2817b7;
module.exports["includesValidContentTreeType"] = $a8768b1a0c8c67c8$export$c7c48cc42c0546b7;

});

parcelRegister("2vuKf", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");


var $bwL2u = parcelRequire("bwL2u");

const $d03c194add2856c2$export$214964e539560671 = (0, $9zUhf.createHook)((0, $bwL2u.Store), {
    selector: (state)=>state.multiSelectMode === (0, $bwL2u.MultiSelectMode).ACTIVE
});
module.exports["useIsMultiSelectActive"] = $d03c194add2856c2$export$214964e539560671;

});

parcelRegister("bwL2u", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $647b75406606f8a7$export$630aa3bad9698e43 = /*#__PURE__*/ function(MultiSelectMode) {
    MultiSelectMode["ACTIVE"] = "active";
    MultiSelectMode["INACTIVE"] = "inactive";
    MultiSelectMode["DISABLED"] = "disabled";
    return MultiSelectMode;
}({});
const $647b75406606f8a7$var$initialState = {
    multiSelectMode: "inactive",
    selectedContent: {},
    count: 0,
    loadingDescendantIds: new Set()
};
const $647b75406606f8a7$var$actions = {
    getState: ()=>({ getState: getState })=>{
            return getState();
        },
    enterMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "active",
                selectedContent: {},
                count: 0
            });
        },
    exitMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "inactive",
                selectedContent: {},
                count: 0
            });
        },
    disableMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "disabled"
            });
        },
    getSelectedDescendantCount: (contentId)=>({ getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            return selectedContent[contentId].selectedDescendantCount;
        },
    updateTotalCount: (delta)=>({ getState: getState, setState: setState })=>{
            const { count: prevCount } = getState();
            setState({
                count: prevCount + delta
            });
        },
    // Update the selected descendant count.
    updateSelectedDescendantsCount: (contentId, descendantCount)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [contentId]: {
                    selectedDescendantCount: descendantCount,
                    deselectedChildren: selectedContent[contentId]?.deselectedChildren ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Update the parent content's deselected children array.
    updateParent: (contentId, parentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [parentId]: {
                    selectedDescendantCount: selectedContent[parentId].selectedDescendantCount,
                    deselectedChildren: new Set([
                        ...selectedContent[parentId].deselectedChildren
                    ].filter((x)=>x !== contentId)) ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    selectNestedContent: (items)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            // First element in items is the current item being selected.
            const currentItemId = items[0].id;
            const newSelectedContent = {
                ...selectedContent
            };
            for (const item of items){
                if (currentItemId === item.id && item.parentId && item.parentId in newSelectedContent) newSelectedContent[item.parentId].deselectedChildren.delete(item.id);
                newSelectedContent[item.id] = {
                    selectedDescendantCount: 0,
                    deselectedChildren: selectedContent[item.id]?.deselectedChildren ?? new Set()
                };
            }
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    incrementAncestors: (ancestorIds, currentContentSelectionCount, countToRemove)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount + currentContentSelectionCount - countToRemove + 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Decrement the selected descendant count of ancestors when a content is deselected.
    decrementAncestors: (ancestorIds, currentContentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const selectItemCount = selectedContent[currentContentId].selectedDescendantCount;
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount - selectItemCount - 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Deselects the content and its descendants, updating the selectedContent state.
    deselectNestedContent: (contentIds, parentIds)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            let newSelectedContent = {
                ...selectedContent
            };
            contentIds.forEach((contentId)=>{
                // Remove the contentId from selectedContent
                const { [contentId]: removed, ...rest } = newSelectedContent;
                newSelectedContent = rest;
                // For each parentId, update its deselectedChildren set
                parentIds.forEach((parentId)=>{
                    if (parentId in newSelectedContent) {
                        const parentContent = {
                            ...newSelectedContent[parentId]
                        };
                        if (!parentContent.deselectedChildren) parentContent.deselectedChildren = new Set();
                        parentContent.deselectedChildren.add(contentId);
                        newSelectedContent[parentId] = parentContent;
                    }
                });
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    clearSelection: ()=>({ setState: setState })=>{
            setState({
                selectedContent: {},
                count: 0
            });
        },
    addLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.add(contentId);
            setState({
                loadingDescendantIds: next
            });
        },
    removeLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.delete(contentId);
            setState({
                loadingDescendantIds: next
            });
        }
};
const $647b75406606f8a7$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $647b75406606f8a7$var$initialState,
    actions: $647b75406606f8a7$var$actions,
    name: 'contentTreeSelection'
});
const $647b75406606f8a7$export$cbc26e3dcdb786e6 = (0, $9zUhf.createHook)($647b75406606f8a7$export$390f32400eaf98c9);
const $647b75406606f8a7$export$ce1c0cba22262219 = (0, $9zUhf.createActionsHook)($647b75406606f8a7$export$390f32400eaf98c9);
module.exports["MultiSelectMode"] = $647b75406606f8a7$export$630aa3bad9698e43;
module.exports["Store"] = $647b75406606f8a7$export$390f32400eaf98c9;
module.exports["useContentTreeSelection"] = $647b75406606f8a7$export$cbc26e3dcdb786e6;
module.exports["useContentTreeSelectionActions"] = $647b75406606f8a7$export$ce1c0cba22262219;

});

parcelRegister("ficwO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

var $6c05dda517103510$export$f69c19e57285b83a = /*#__PURE__*/ function(Message) {
    Message[Message["ContentCreated"] = 0] = "ContentCreated";
    Message[Message["ContentUnarchived"] = 1] = "ContentUnarchived";
    return Message;
}({});
class $6c05dda517103510$var$MessageBus {
    publish(type, data) {
        if (!this.subscribers[type]) return;
        this.subscribers[type].forEach((subscriber)=>subscriber(data));
    }
    subscribe(type, callback) {
        if (!this.subscribers[type]) this.subscribers[type] = [];
        this.subscribers[type].push(callback);
    }
    unsubscribe(type, callback) {
        this.subscribers[type] = this.subscribers[type].filter((subscriber)=>subscriber !== callback);
    }
    constructor(){
        this.subscribers = {};
    }
}
const $6c05dda517103510$var$messageBus = new $6c05dda517103510$var$MessageBus();
const $6c05dda517103510$export$c4ca85b4851515e2 = (type)=>{
    return (data)=>{
        $6c05dda517103510$var$messageBus.publish(type, data);
    };
};
const $6c05dda517103510$export$99473f2ba2f9f18 = (0, $3u0dr.isReactCompilerActiveV1)() ? (type, callback)=>{
    const $ = (0, $frIzR.c)(4);
    let t0;
    let t1;
    if ($[0] !== callback || $[1] !== type) {
        t0 = ()=>{
            $6c05dda517103510$var$messageBus.subscribe(type, callback);
            return ()=>{
                $6c05dda517103510$var$messageBus.unsubscribe(type, callback);
            };
        };
        t1 = [
            callback,
            type
        ];
        $[0] = callback;
        $[1] = type;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $42omo.useEffect)(t0, t1);
} : (type, callback)=>{
    (0, $42omo.useEffect)(()=>{
        $6c05dda517103510$var$messageBus.subscribe(type, callback);
        return ()=>{
            $6c05dda517103510$var$messageBus.unsubscribe(type, callback);
        };
    }, [
        callback,
        type
    ]);
};
module.exports["Message"] = $6c05dda517103510$export$f69c19e57285b83a;
module.exports["useMessagePublisher"] = $6c05dda517103510$export$c4ca85b4851515e2;
module.exports["useMessageSubscriber"] = $6c05dda517103510$export$99473f2ba2f9f18;

});

parcelRegister("3SAD5", function(module, exports) {
const $6311439f964a7bc2$export$59da04d16460addd = (tree, parentId, itemId, index)=>{
    const parent = tree.items[parentId];
    const newChildren = [
        ...parent.children
    ];
    newChildren.splice(index, 0, itemId);
    return $6311439f964a7bc2$var$mutateTree(tree, parentId, {
        children: newChildren,
        hasChildren: true
    });
};
const $6311439f964a7bc2$export$7ae609f7af59e4f7 = (tree, parentId, itemId)=>{
    const parent = tree.items[parentId];
    const newChildren = parent.children.filter((id)=>id !== itemId);
    const hasChildren = newChildren.length > 0 || Boolean(parent.hasAdditionalChildren);
    if (newChildren.length !== parent.children.length) return $6311439f964a7bc2$var$mutateTree(tree, parentId, {
        children: newChildren,
        hasChildren: hasChildren,
        isExpanded: hasChildren && parent.isExpanded
    });
    return tree;
};
const $6311439f964a7bc2$export$151553fb522a6220 = (tree, itemId, data)=>{
    return $6311439f964a7bc2$var$mutateTree(tree, itemId, {
        data: {
            ...tree.items[itemId].data,
            ...data
        }
    });
};
function $6311439f964a7bc2$export$7714407ea87aca85(tree, source, destination) {
    const { items: items } = tree;
    const newItems = {
        ...items
    };
    // remove item from old location
    const sourceChildren = [
        ...newItems[source.parentId].children
    ];
    sourceChildren.splice(source.index, 1);
    newItems[source.parentId] = {
        ...newItems[source.parentId],
        children: sourceChildren,
        hasChildren: Boolean(sourceChildren.length)
    };
    // put item in its new location
    const destinationParent = newItems[destination.parentId];
    const destinationChildren = [
        ...destinationParent.children
    ];
    const itemId = items[source.parentId].children[source.index];
    if (typeof destination.index === 'undefined') /**
     * When the destination index is undefined, we "combine" the items by appending the item to the end of destination.
     * We ONLY do this if the destination has already loaded children OR is a leaf node.
     * If the destination is an unexpanded item with children, the moved item will appear when the user expands.
     */ destinationChildren.push(itemId);
    else destinationChildren.splice(destination.index, 0, itemId);
    newItems[destination.parentId] = {
        ...newItems[destination.parentId],
        children: destinationChildren,
        hasChildren: true,
        // This data is needed to determine whether children have been loaded already.
        // A page might have children that were added via DnD, but have "additional" children yet to be fetched from the server.
        hasAdditionalChildren: destinationParent.hasAdditionalChildren || destinationParent.hasChildren && destinationParent.children.length === 0
    };
    return {
        ...tree,
        items: newItems
    };
}
const $6311439f964a7bc2$var$mutateTree = (tree, itemId, mutation)=>{
    const itemToChange = tree.items[itemId];
    if (!itemToChange) // Item not found
    return tree;
    // Returning a clone of the tree structure and overwriting the field coming in mutation
    return {
        // rootId should not change
        rootId: tree.rootId,
        items: {
            // copy all old items
            ...tree.items,
            // overwriting only the item being changed
            [itemId]: {
                ...itemToChange,
                ...mutation
            }
        }
    };
};
module.exports["addChild"] = $6311439f964a7bc2$export$59da04d16460addd;
module.exports["removeChild"] = $6311439f964a7bc2$export$7ae609f7af59e4f7;
module.exports["moveItemOnTree"] = $6311439f964a7bc2$export$7714407ea87aca85;

});

parcelRegister("dL6iS", function(module, exports) {

var $hHyea = parcelRequire("hHyea");


var $9JSQw = parcelRequire("9JSQw");


var $bVtKl = parcelRequire("bVtKl");

/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $a0448de2cf8bee01$var$without = $9JSQw(function(array, values) {
    return $bVtKl(array) ? $hHyea(array, values) : [];
});
module.exports = $a0448de2cf8bee01$var$without;

});

parcelRegister("dd6Gw", function(module, exports) {
// This type matches the GraphQL result from fetching something with `properties`.
const $411dffa4c6a383d3$export$9f5d37e817ec8d6 = (page)=>{
    const editorProperty = page?.properties?.nodes?.find((prop)=>prop?.key === 'editor');
    const editorVersion = (editorProperty?.value || '').replace(/['"]+/g, '');
    if (editorVersion !== 'v1' && editorVersion !== 'v2') return '';
    else return editorVersion;
};
module.exports["getEditorVersionFromPageProperties"] = $411dffa4c6a383d3$export$9f5d37e817ec8d6;

});

parcelRegister("jwg5H", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ed61048aa16089ca$export$a423abb15d3d6d30 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "OOnQb",
    name: "BulkDeletePagesActionLoader",
    loader: async ()=>(await (parcelRequire("4Kw4j"))).BulkDeletePagesAction
});
module.exports["BulkDeletePagesActionLoader"] = $ed61048aa16089ca$export$a423abb15d3d6d30;

});

parcelRegister("4Kw4j", function(module, exports) {

let $375455727e8eb8a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $375455727e8eb8a6$var$load("6wr18"),
    $375455727e8eb8a6$var$load("73HOd"),
    $375455727e8eb8a6$var$load("ffEVr"),
    $375455727e8eb8a6$var$load("Wowvf"),
    $375455727e8eb8a6$var$load("jXx9i"),
    $375455727e8eb8a6$var$load("hhss7"),
    $375455727e8eb8a6$var$load("4JUnA")
]).then(()=>parcelRequire('11cB0'));

});

parcelRegister("eQjI7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f8c65fa1d909f5a2$export$3ef64b4ca9fc58eb = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Xv9Y3",
    name: "BulkArchivePagesLoader",
    loader: async ()=>(await (parcelRequire("7fkEY"))).BulkArchivePagesLoader
});
module.exports["BulkArchivePagesLoader"] = $f8c65fa1d909f5a2$export$3ef64b4ca9fc58eb;

});

parcelRegister("7fkEY", function(module, exports) {

let $5469f5c0b7ed2841$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5469f5c0b7ed2841$var$load("6kZfp"),
    $5469f5c0b7ed2841$var$load("2UbDA"),
    $5469f5c0b7ed2841$var$load("zjNVa"),
    $5469f5c0b7ed2841$var$load("6wr18"),
    $5469f5c0b7ed2841$var$load("kH8lz"),
    $5469f5c0b7ed2841$var$load("ffEVr"),
    $5469f5c0b7ed2841$var$load("Wowvf"),
    $5469f5c0b7ed2841$var$load("kHOMt"),
    $5469f5c0b7ed2841$var$load("jXx9i"),
    $5469f5c0b7ed2841$var$load("nbjnv"),
    $5469f5c0b7ed2841$var$load("9ftJe"),
    $5469f5c0b7ed2841$var$load("hhss7"),
    $5469f5c0b7ed2841$var$load("anGwD")
]).then(()=>parcelRequire('1nPts'));

});

parcelRegister("abCbd", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $49f30f782ee3886b$export$dde867dc2e19cdfb = /*#__PURE__*/ function(ActionStatus) {
    ActionStatus["LOADING"] = "loading";
    ActionStatus["ERROR"] = "error";
    ActionStatus["SUCCESS"] = "success";
    return ActionStatus;
}({});
const $49f30f782ee3886b$export$a047e1504a58a095 = 'https://support.atlassian.com/contact/#/';
const $49f30f782ee3886b$export$992f6917cca3802d = 'https://support.atlassian.com/confluence-cloud/docs/archive-pages/';
const $49f30f782ee3886b$export$f077813e47f96ab7 = 'https://support.atlassian.com/confluence-cloud/docs/delete-restore-or-purge-a-page/';
const $49f30f782ee3886b$export$90622b83e51be397 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
var $49f30f782ee3886b$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["ARCHIVED"] = "archived";
    ContentStatus["RESTORED"] = "restored";
    // Trashed pages can be restored.
    ContentStatus["TRASHED"] = "trashed";
    return ContentStatus;
}({});
const $49f30f782ee3886b$export$c047260051351df3 = 100;
module.exports["ActionStatus"] = $49f30f782ee3886b$export$dde867dc2e19cdfb;
module.exports["LINK_TO_SUPPORT_CONTACT"] = $49f30f782ee3886b$export$a047e1504a58a095;
module.exports["ARCHIVE_SUPPORT_LINK"] = $49f30f782ee3886b$export$992f6917cca3802d;
module.exports["DELETE_SUPPORT_LINK"] = $49f30f782ee3886b$export$f077813e47f96ab7;
module.exports["PAGE_RESTRICTIONS_SUPPORT_LINK"] = $49f30f782ee3886b$export$90622b83e51be397;
module.exports["ContentStatus"] = $49f30f782ee3886b$export$b2be22e9d5dd3927;
module.exports["BULK_DELETE_PAGE_SELECTION_LIMIT_DEFAULT"] = $49f30f782ee3886b$export$c047260051351df3;

});

parcelRegister("8Hyz1", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $2f7c8c88765be2b1$var$PostOfficeSideNavMessageContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $2f7c8c88765be2b1$export$730cc5718beea0d0 = ()=>{
    return (0, $42omo.useContext)($2f7c8c88765be2b1$var$PostOfficeSideNavMessageContext);
};
const $2f7c8c88765be2b1$export$1a1a764f5b0fd0ac = ({ children: children })=>{
    const [enabledMessages, setEnabledMessages] = (0, $42omo.useState)([]);
    const enablePostOfficeSideNavMessage = (0, $42omo.useCallback)((message)=>{
        setEnabledMessages((prev)=>{
            if (prev.includes(message)) return prev;
            return [
                ...prev,
                message
            ];
        });
    }, []);
    const value = (0, $42omo.useMemo)(()=>({
            enabledMessages: enabledMessages,
            enablePostOfficeSideNavMessage: enablePostOfficeSideNavMessage
        }), [
        enabledMessages,
        enablePostOfficeSideNavMessage
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($2f7c8c88765be2b1$var$PostOfficeSideNavMessageContext.Provider, {
        value: value,
        children: children
    });
};
module.exports["usePostOfficeSideNavMessages"] = $2f7c8c88765be2b1$export$730cc5718beea0d0;
module.exports["PostOfficeSideNavMessageProvider"] = $2f7c8c88765be2b1$export$1a1a764f5b0fd0ac;

});

parcelRegister("g0MxG", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ab7921964510845f$export$e3668039106e3bc = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "CQdGh",
    name: "PageTreeAfterIconLoader",
    loader: async ()=>(await (parcelRequire("8m9Vr"))).PageTreeAfterIcon
});
module.exports["PageTreeAfterIconLoader"] = $ab7921964510845f$export$e3668039106e3bc;

});

parcelRegister("8m9Vr", function(module, exports) {

let $615813c87f230984$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $615813c87f230984$var$load("6wr18"),
    $615813c87f230984$var$load("ffEVr"),
    $615813c87f230984$var$load("dkv9z")
]).then(()=>parcelRequire('4Nj9v'));

});

parcelRegister("hySOz", function(module, exports) {
$parcel$export(module.exports, "ConditionalInlineRename", () => (parcelRequire("l0o5N")).ConditionalInlineRename);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");


var $l0o5N = parcelRequire("l0o5N");


const $4938a4ac4072e24f$export$5dca550a712dab6d = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "uk9Wl",
    name: "PageTreeQuickActions",
    loader: async ()=>(await (parcelRequire("irljW"))).PageTreeQuickActions
});

const $4938a4ac4072e24f$export$fd6f8aa63961aeed = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "0zuTW",
    name: "InlineRename",
    loader: async ()=>(await (parcelRequire("2majz"))).InlineRename,
    loading: ({ children: children })=>children
});
module.exports["PageTreeQuickActions"] = $4938a4ac4072e24f$export$5dca550a712dab6d;
module.exports["InlineRename"] = $4938a4ac4072e24f$export$fd6f8aa63961aeed;

});

parcelRegister("irljW", function(module, exports) {

let $d6cb4970771be651$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d6cb4970771be651$var$load("6wr18"),
    $d6cb4970771be651$var$load("ffEVr"),
    $d6cb4970771be651$var$load("clpSH")
]).then(()=>parcelRequire('cAbTs'));

});

parcelRegister("2majz", function(module, exports) {

let $1b75a32547f715a5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1b75a32547f715a5$var$load("6wr18"),
    $1b75a32547f715a5$var$load("dlm6q"),
    $1b75a32547f715a5$var$load("7EorR"),
    $1b75a32547f715a5$var$load("kHOMt"),
    $1b75a32547f715a5$var$load("hhss7"),
    $1b75a32547f715a5$var$load("Wowvf"),
    $1b75a32547f715a5$var$load("ffEVr"),
    $1b75a32547f715a5$var$load("2bmVk"),
    $1b75a32547f715a5$var$load("PNyg1")
]).then(()=>parcelRequire('7K7RC'));

});

parcelRegister("l0o5N", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $hySOz = parcelRequire("hySOz");

const $208c4dcc8619080d$export$2305c9520b042855 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    let children;
    let isEditingTitle;
    let props;
    if ($[0] !== t0) {
        ({ children: children, isEditingTitle: isEditingTitle, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = isEditingTitle;
        $[3] = props;
    } else {
        children = $[1];
        isEditingTitle = $[2];
        props = $[3];
    }
    if (isEditingTitle) {
        let t1;
        if ($[4] !== children || $[5] !== isEditingTitle || $[6] !== props) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hySOz.InlineRename), {
                ...props,
                isEditingTitle: isEditingTitle
            }, children);
            $[4] = children;
            $[5] = isEditingTitle;
            $[6] = props;
            $[7] = t1;
        } else t1 = $[7];
        return t1;
    }
    let t1;
    if ($[8] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
        $[8] = children;
        $[9] = t1;
    } else t1 = $[9];
    return t1;
} : ({ children: children, isEditingTitle: isEditingTitle, ...props })=>{
    if (isEditingTitle) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hySOz.InlineRename), {
        ...props,
        isEditingTitle: isEditingTitle
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
};
module.exports["ConditionalInlineRename"] = $208c4dcc8619080d$export$2305c9520b042855;

});

parcelRegister("5C17p", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6p02T = parcelRequire("6p02T");


var $aU0Vx = parcelRequire("aU0Vx");

const $2703b103d1a678c3$export$cba03ec732da70ea = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { isHoverPageCardOptedIn: isHoverPageCardOptedIn, children: children, title: title, isQuickActionsOpen: isQuickActionsOpen } = t0;
    let t1;
    if ($[0] !== children || $[1] !== isHoverPageCardOptedIn || $[2] !== isQuickActionsOpen || $[3] !== title) {
        t1 = isHoverPageCardOptedIn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aU0Vx.PageTreeTooltip), {
            title: (0, $6p02T.cleanExcerpt)(title),
            isQuickActionsOpen: isQuickActionsOpen
        }, children);
        $[0] = children;
        $[1] = isHoverPageCardOptedIn;
        $[2] = isQuickActionsOpen;
        $[3] = title;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ isHoverPageCardOptedIn: isHoverPageCardOptedIn, children: children, title: title, isQuickActionsOpen: isQuickActionsOpen })=>{
    return isHoverPageCardOptedIn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aU0Vx.PageTreeTooltip), {
        title: (0, $6p02T.cleanExcerpt)(title),
        isQuickActionsOpen: isQuickActionsOpen
    }, children);
};
module.exports["ConditionalTreeItemTooltip"] = $2703b103d1a678c3$export$cba03ec732da70ea;

});

parcelRegister("aU0Vx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");

const $17e4300d7b59a3d4$export$6c94635022fac1d1 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children, title: title, isQuickActionsOpen: isQuickActionsOpen } = t0;
    const t1 = !isQuickActionsOpen && title ? title : null;
    let t2;
    if ($[0] !== children || $[1] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t1,
            position: "top",
            delay: 750,
            hideTooltipOnMouseDown: true
        }, children);
        $[0] = children;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children, title: title, isQuickActionsOpen: isQuickActionsOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: !isQuickActionsOpen && title ? title : null,
        position: "top",
        delay: 750,
        hideTooltipOnMouseDown: true
    }, children);
module.exports["PageTreeTooltip"] = $17e4300d7b59a3d4$export$6c94635022fac1d1;

});


//# sourceMappingURL=PageTree.2433bf8b.js.map
